(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("WokForms", [], factory);
	else if(typeof exports === 'object')
		exports["WokForms"] = factory();
	else
		root["WokForms"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 49);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = require("vue-property-decorator");

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_vue__ = __webpack_require__(13);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var FormComponent = /** @class */ (function (_super) {
    __extends(FormComponent, _super);
    function FormComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormComponent.prototype.created = function () {
        // Look for parent form and save it in this.$form.
        var c = this.$parent;
        while (c) {
            if (c instanceof __WEBPACK_IMPORTED_MODULE_1__form_vue__["a" /* default */]) {
                this.$form = c;
                break;
            }
            c = c.$parent;
        }
    };
    return FormComponent;
}(__WEBPACK_IMPORTED_MODULE_0_vue___default.a));
/* harmony default export */ __webpack_exports__["a"] = (FormComponent);


/***/ }),
/* 3 */
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = E;
/* unused harmony export EventTargetWrapper */
/* harmony export (immutable) */ __webpack_exports__["a"] = D;
/* unused harmony export DomWrapper */
function E(e) {
    return new EventTargetWrapper(e);
}
var EventTargetWrapper = /** @class */ (function () {
    function EventTargetWrapper(e) {
        this.e = e;
    }
    EventTargetWrapper.prototype.once = function (type, listener, isCapture) {
        var e = this.e;
        var l = function (evt) {
            var v = listener(evt);
            if (v !== false) {
                e.removeEventListener(type, l, isCapture);
            }
        };
        e.addEventListener(type, l, isCapture);
    };
    return EventTargetWrapper;
}());

function D(e) {
    return new DomWrapper(e);
}
var DomWrapper = /** @class */ (function () {
    function DomWrapper(e) {
        this.e = e;
    }
    DomWrapper.prototype.inside = function (container) {
        return inside(container, this.e);
    };
    DomWrapper.prototype.contains = function (element) {
        return inside(this.e, element);
    };
    DomWrapper.prototype.closest = function (selector) {
        var e = this.e;
        while (e !== null) {
            if (e.msMatchesSelector ? e.msMatchesSelector(selector) : e.matches(selector)) {
                return e;
            }
            e = e.parentElement;
        }
        return e;
    };
    return DomWrapper;
}());

// Helper functions
function isEventListenerObject(arg) {
    return arg.handleEvent !== undefined;
}
function inside(container, target) {
    if (target === null) {
        return false;
    }
    if (target === container) {
        return true;
    }
    return inside(container, target.parentElement);
}


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_text_vue__ = __webpack_require__(22);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b54aec0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_text_vue__ = __webpack_require__(65);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_text_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b54aec0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_text_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/entries/entry-text.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-9b54aec0", Component.options)
  } else {
    hotAPI.reload("data-v-9b54aec0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = require("vue-class-component");

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = require("moment");

/***/ }),
/* 8 */
/***/ (function(module, exports) {

module.exports = require("prosemirror-state");

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = extractOptions;
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
function extractOptions(nodes) {
    var options = [];
    if (nodes) {
        try {
            for (var nodes_1 = __values(nodes), nodes_1_1 = nodes_1.next(); !nodes_1_1.done; nodes_1_1 = nodes_1.next()) {
                var n = nodes_1_1.value;
                if (n.tag === "option" && n.children && n.data && (n.data.domProps || n.data.attrs)) {
                    var v = (n.data.domProps && n.data.domProps["value"]) || (n.data.attrs && n.data.attrs["value"]);
                    var a = (n.data.domProps && n.data.domProps["name"]) || (n.data.attrs && n.data.attrs["name"]);
                    var o = { label: n.children[0].text || "", value: v };
                    if (a) {
                        o.name = a;
                    }
                    options.push(o);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (nodes_1_1 && !nodes_1_1.done && (_a = nodes_1.return)) _a.call(nodes_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    return options.length > 0 ? options : null;
    var e_1, _a;
}


/***/ }),
/* 10 */
/***/ (function(module, exports) {

module.exports = require("prosemirror-commands");

/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports = require("prosemirror-schema-list");

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isIFormEntry", function() { return isIFormEntry; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__form_form_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_row_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_actions_row_vue__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_pill_vue__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_pill_switch_vue__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__texts_form_title_vue__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__texts_form_text_vue__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__entries_entry_spacer_vue__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__entries_entry_text_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__entries_entry_textarea_vue__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__entries_entry_password_vue__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__entries_entry_mail_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__entries_entry_phone_vue__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__entries_entry_pnr_vue__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__entries_entry_euro_vue__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__entries_entry_color_vue__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pickers_color_picker_vue__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__entries_entry_select_vue__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__entries_entry_checkbox_group_vue__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__entries_entry_radio_group_vue__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__entries_entry_date_vue__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pickers_date_picker_vue__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__entries_entry_period_vue__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pickers_period_picker_vue__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__entries_entry_image_vue__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pickers_image_picker_vue__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__entries_entry_time_vue__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__entries_entry_upload_vue__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pickers_file_picker_vue__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__entries_entry_html_vue__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__form_form_component__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__lib_dom__ = __webpack_require__(4);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_31__lib_dom__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_31__lib_dom__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Form", function() { return __WEBPACK_IMPORTED_MODULE_0__form_form_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormRow", function() { return __WEBPACK_IMPORTED_MODULE_1__form_row_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ActionsRow", function() { return __WEBPACK_IMPORTED_MODULE_2__form_actions_row_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Pill", function() { return __WEBPACK_IMPORTED_MODULE_3__form_pill_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PillSwitch", function() { return __WEBPACK_IMPORTED_MODULE_4__form_pill_switch_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormTitle", function() { return __WEBPACK_IMPORTED_MODULE_5__texts_form_title_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormText", function() { return __WEBPACK_IMPORTED_MODULE_6__texts_form_text_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EntrySpacer", function() { return __WEBPACK_IMPORTED_MODULE_7__entries_entry_spacer_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EntryText", function() { return __WEBPACK_IMPORTED_MODULE_8__entries_entry_text_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EntryTextArea", function() { return __WEBPACK_IMPORTED_MODULE_9__entries_entry_textarea_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EntryPassword", function() { return __WEBPACK_IMPORTED_MODULE_10__entries_entry_password_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EntryMail", function() { return __WEBPACK_IMPORTED_MODULE_11__entries_entry_mail_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EntryPhone", function() { return __WEBPACK_IMPORTED_MODULE_12__entries_entry_phone_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EntryPnr", function() { return __WEBPACK_IMPORTED_MODULE_13__entries_entry_pnr_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EntryEuro", function() { return __WEBPACK_IMPORTED_MODULE_14__entries_entry_euro_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EntryColor", function() { return __WEBPACK_IMPORTED_MODULE_15__entries_entry_color_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ColorPicker", function() { return __WEBPACK_IMPORTED_MODULE_16__pickers_color_picker_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EntrySelect", function() { return __WEBPACK_IMPORTED_MODULE_17__entries_entry_select_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EntryCheckboxGroup", function() { return __WEBPACK_IMPORTED_MODULE_18__entries_entry_checkbox_group_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EntryRadioGroup", function() { return __WEBPACK_IMPORTED_MODULE_19__entries_entry_radio_group_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EntryDate", function() { return __WEBPACK_IMPORTED_MODULE_20__entries_entry_date_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DatePicker", function() { return __WEBPACK_IMPORTED_MODULE_21__pickers_date_picker_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EntryPeriod", function() { return __WEBPACK_IMPORTED_MODULE_22__entries_entry_period_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PeriodPicker", function() { return __WEBPACK_IMPORTED_MODULE_23__pickers_period_picker_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EntryImage", function() { return __WEBPACK_IMPORTED_MODULE_24__entries_entry_image_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ImagePicker", function() { return __WEBPACK_IMPORTED_MODULE_25__pickers_image_picker_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EntryTime", function() { return __WEBPACK_IMPORTED_MODULE_26__entries_entry_time_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EntryUpload", function() { return __WEBPACK_IMPORTED_MODULE_27__entries_entry_upload_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FilePicker", function() { return __WEBPACK_IMPORTED_MODULE_28__pickers_file_picker_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormComponent", function() { return __WEBPACK_IMPORTED_MODULE_30__form_form_component__["a"]; });
// Import, then re-export all default WOK Forms widgets.
































// WokForms Vue plugin, to automatically register all components.
/* harmony default export */ __webpack_exports__["default"] = ({
    install: function (V, options) {
        V.component("wok-form", __WEBPACK_IMPORTED_MODULE_0__form_form_vue__["a" /* default */]);
        V.component("form-row", __WEBPACK_IMPORTED_MODULE_1__form_row_vue__["a" /* default */]);
        V.component("actions-row", __WEBPACK_IMPORTED_MODULE_2__form_actions_row_vue__["a" /* default */]);
        V.component("wok-pill", __WEBPACK_IMPORTED_MODULE_3__form_pill_vue__["a" /* default */]);
        V.component("wok-pill-switch", __WEBPACK_IMPORTED_MODULE_4__form_pill_switch_vue__["a" /* default */]);
        V.component("form-title", __WEBPACK_IMPORTED_MODULE_5__texts_form_title_vue__["a" /* default */]);
        V.component("form-text", __WEBPACK_IMPORTED_MODULE_6__texts_form_text_vue__["a" /* default */]);
        V.component("entry-spacer", __WEBPACK_IMPORTED_MODULE_7__entries_entry_spacer_vue__["a" /* default */]);
        V.component("entry-text", __WEBPACK_IMPORTED_MODULE_8__entries_entry_text_vue__["a" /* default */]);
        V.component("entry-textarea", __WEBPACK_IMPORTED_MODULE_9__entries_entry_textarea_vue__["a" /* default */]);
        V.component("entry-password", __WEBPACK_IMPORTED_MODULE_10__entries_entry_password_vue__["a" /* default */]);
        V.component("entry-mail", __WEBPACK_IMPORTED_MODULE_11__entries_entry_mail_vue__["a" /* default */]);
        V.component("entry-phone", __WEBPACK_IMPORTED_MODULE_12__entries_entry_phone_vue__["a" /* default */]);
        V.component("entry-pnr", __WEBPACK_IMPORTED_MODULE_13__entries_entry_pnr_vue__["a" /* default */]);
        V.component("entry-euro", __WEBPACK_IMPORTED_MODULE_14__entries_entry_euro_vue__["a" /* default */]);
        V.component("entry-color", __WEBPACK_IMPORTED_MODULE_15__entries_entry_color_vue__["a" /* default */]);
        V.component("color-picker", __WEBPACK_IMPORTED_MODULE_16__pickers_color_picker_vue__["a" /* default */]);
        V.component("entry-select", __WEBPACK_IMPORTED_MODULE_17__entries_entry_select_vue__["a" /* default */]);
        V.component("entry-checkbox-group", __WEBPACK_IMPORTED_MODULE_18__entries_entry_checkbox_group_vue__["a" /* default */]);
        V.component("entry-radio-group", __WEBPACK_IMPORTED_MODULE_19__entries_entry_radio_group_vue__["a" /* default */]);
        V.component("entry-date", __WEBPACK_IMPORTED_MODULE_20__entries_entry_date_vue__["a" /* default */]);
        V.component("date-picker", __WEBPACK_IMPORTED_MODULE_21__pickers_date_picker_vue__["a" /* default */]);
        V.component("entry-period", __WEBPACK_IMPORTED_MODULE_22__entries_entry_period_vue__["a" /* default */]);
        V.component("period-picker", __WEBPACK_IMPORTED_MODULE_23__pickers_period_picker_vue__["a" /* default */]);
        V.component("entry-image", __WEBPACK_IMPORTED_MODULE_24__entries_entry_image_vue__["a" /* default */]);
        V.component("image-picker", __WEBPACK_IMPORTED_MODULE_25__pickers_image_picker_vue__["a" /* default */]);
        V.component("entry-time", __WEBPACK_IMPORTED_MODULE_26__entries_entry_time_vue__["a" /* default */]);
        V.component("entry-upload", __WEBPACK_IMPORTED_MODULE_27__entries_entry_upload_vue__["a" /* default */]);
        V.component("file-picker", __WEBPACK_IMPORTED_MODULE_28__pickers_file_picker_vue__["a" /* default */]);
        V.component("entry-html", __WEBPACK_IMPORTED_MODULE_29__entries_entry_html_vue__["a" /* default */]);
    }
});
function isIFormEntry(arg) {
    return (arg.name !== undefined || arg.names !== undefined) && arg.value !== undefined;
}
// Also export all components.



/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_vue__ = __webpack_require__(14);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49f8f026_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_vue__ = __webpack_require__(50);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49f8f026_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/form/form.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-49f8f026", Component.options)
  } else {
    hotAPI.reload("data-v-49f8f026", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index__ = __webpack_require__(12);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var Form = /** @class */ (function (_super) {
    __extends(Form, _super);
    function Form() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Form.prototype.getEntries = function () {
        var entries = new Array();
        for (var i = 0; i < this.$children.length; i++) {
            _getEntries(this.$children[i], entries);
        }
        return entries;
    };
    Form.prototype.onSubmit = function (evt) {
        var form = this.$refs.form;
        var data = new FormData(form);
        if (this.submitButton && this.submitButton.name) {
            data.append(this.submitButton.name, this.submitButton.value || '');
        }
        this.$emit("submit", { target: this, form: form, data: data });
    };
    Form.prototype.onButtonClick = function (evt) {
        if (evt.target instanceof HTMLButtonElement) {
            this.submitButton = evt.target;
        }
    };
    Form.prototype.getEntry = function (name) {
        return this.getEntries().filter(function (x) { return x.name === name; })[0];
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], Form.prototype, "name", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], Form.prototype, "method", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], Form.prototype, "action", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], Form.prototype, "enctype", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], Form.prototype, "readonly", void 0);
    Form = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], Form);
    return Form;
}(__WEBPACK_IMPORTED_MODULE_0_vue___default.a));
/* harmony default export */ __webpack_exports__["a"] = (Form);
function _getEntries(component, list) {
    if (Object(__WEBPACK_IMPORTED_MODULE_2__index__["isIFormEntry"])(component)) {
        list.push(component);
    }
    for (var i = 0; i < component.$children.length; i++) {
        _getEntries(component.$children[i], list);
    }
}


/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var Row = /** @class */ (function (_super) {
    __extends(Row, _super);
    function Row() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], Row.prototype, "variant", void 0);
    Row = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], Row);
    return Row;
}(__WEBPACK_IMPORTED_MODULE_0_vue___default.a));
/* harmony default export */ __webpack_exports__["a"] = (Row);


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var ActionsRow = /** @class */ (function (_super) {
    __extends(ActionsRow, _super);
    function ActionsRow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ActionsRow.prototype.created = function () {
        // Set some defaults: left + right with a small offset.
        var c = 0, l = 5, r = 5;
        if (this.size) {
            var p = this.size.split('/');
            if (p.length === 1) {
                c = parseInt(p[0]);
                l = r = Math.floor((12 - c) / 2);
            }
            else if (p.length === 2) {
                l = parseInt(p[0]);
                r = parseInt(p[1]);
            }
            else {
                l = parseInt(p[0]);
                c = parseInt(p[1]);
                r = parseInt(p[2]);
            }
        }
        this.offset = Math.floor((12 - l - c - r) / 2).toFixed();
        this.lSize = l.toFixed();
        this.cSize = c.toFixed();
        this.rSize = r.toFixed();
    };
    ActionsRow.prototype.getClassName = function (position) {
        var offset = this.offset, size;
        switch (position) {
            case "left":
                size = this.lSize;
                break;
            case "center":
                size = this.cSize;
                break;
            case "right":
                size = this.rSize;
                break;
        }
        var names = ["c-" + position + " c-size-" + size];
        if (position === "left" && offset !== "0") {
            names.push("c-offset-" + offset);
        }
        return names;
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], ActionsRow.prototype, "variant", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], ActionsRow.prototype, "size", void 0);
    ActionsRow = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], ActionsRow);
    return ActionsRow;
}(__WEBPACK_IMPORTED_MODULE_0_vue___default.a));
/* harmony default export */ __webpack_exports__["a"] = (ActionsRow);


/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var Pill = /** @class */ (function (_super) {
    __extends(Pill, _super);
    function Pill() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], Pill.prototype, "variant", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], Pill.prototype, "spacing", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], Pill.prototype, "rounded", void 0);
    Pill = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], Pill);
    return Pill;
}(__WEBPACK_IMPORTED_MODULE_0_vue___default.a));
/* harmony default export */ __webpack_exports__["a"] = (Pill);


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_form_component__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var PillSwitch = /** @class */ (function (_super) {
    __extends(PillSwitch, _super);
    function PillSwitch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Data
        _this.value = _this.initialValue || "";
        return _this;
    }
    PillSwitch.prototype.created = function () {
        _super.prototype.created.call(this);
    };
    // Events.
    PillSwitch.prototype.onChange = function (evt) {
        if (evt.target instanceof HTMLInputElement) {
            this.value = evt.target.value;
            this.$form.$emit("change", { target: this, value: this.value });
        }
    };
    Object.defineProperty(PillSwitch.prototype, "title", {
        // Generated properties.
        get: function () {
            var _this = this;
            var curr = (this.options.filter(function (x) { return x.value == _this.value; }))[0];
            return curr ? curr.title : null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PillSwitch.prototype, "optionsCount", {
        get: function () {
            return this.options && this.options.length || 0;
        },
        enumerable: true,
        configurable: true
    });
    // Methods.
    PillSwitch.prototype.slotName = function (index) {
        return "option" + index;
    };
    PillSwitch.prototype.slotIsVisible = function (index) {
        if (this.options) {
            for (var i = 0; i < this.options.length; i++) {
                if (this.value === this.options[i].value) {
                    return index - 1 == i;
                }
            }
        }
        return false;
    };
    PillSwitch.prototype.getId = function (item) {
        return this.name + "_" + item.value;
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], PillSwitch.prototype, "name", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], PillSwitch.prototype, "variant", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], PillSwitch.prototype, "spacing", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], PillSwitch.prototype, "rounded", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], PillSwitch.prototype, "initialValue", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], PillSwitch.prototype, "options", void 0);
    PillSwitch = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"]
    ], PillSwitch);
    return PillSwitch;
}(__WEBPACK_IMPORTED_MODULE_1__form_form_component__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (PillSwitch);


/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var FormTitle = /** @class */ (function (_super) {
    __extends(FormTitle, _super);
    function FormTitle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], FormTitle.prototype, "variant", void 0);
    FormTitle = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], FormTitle);
    return FormTitle;
}(__WEBPACK_IMPORTED_MODULE_0_vue___default.a));
/* harmony default export */ __webpack_exports__["a"] = (FormTitle);


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var FormText = /** @class */ (function (_super) {
    __extends(FormText, _super);
    function FormText() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], FormText.prototype, "variant", void 0);
    FormText = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], FormText);
    return FormText;
}(__WEBPACK_IMPORTED_MODULE_0_vue___default.a));
/* harmony default export */ __webpack_exports__["a"] = (FormText);


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var EntrySpacer = /** @class */ (function (_super) {
    __extends(EntrySpacer, _super);
    function EntrySpacer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(EntrySpacer.prototype, "cellClassName", {
        // Generated properties.
        get: function () {
            var c = this.size ? "c-entry-spacer-" + this.size : "c-entry-spacer";
            return c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntrySpacer.prototype, "entryClassName", {
        get: function () {
            var d = {
                "entry-spacer": true
            };
            if (this.variant) {
                d['entry-spacer--' + this.variant] = true;
            }
            return d;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntrySpacer.prototype, "size", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntrySpacer.prototype, "variant", void 0);
    EntrySpacer = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], EntrySpacer);
    return EntrySpacer;
}(__WEBPACK_IMPORTED_MODULE_0_vue___default.a));
/* harmony default export */ __webpack_exports__["a"] = (EntrySpacer);


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_form_component__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var EntryText = /** @class */ (function (_super) {
    __extends(EntryText, _super);
    function EntryText() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Data
        _this.value = _this.initialValue != null ? _this.initialValue.toString() : '';
        _this.valid = false;
        _this.hasFocus = false;
        _this.showErrors = false;
        return _this;
    }
    EntryText.prototype.onInitialValueChanged = function (newValue) {
        this.value = newValue != null ? newValue.toString() : '';
        this.validate();
    };
    EntryText.prototype.fromValue = function (value) {
        switch (this.type) {
            case 'boolean':
                if (value != '') {
                    return (/true/i).test(value);
                }
                return null;
            case 'number':
                return !!value && parseInt(value) || null;
            default:
                return value || null;
        }
    };
    EntryText.prototype.created = function () {
        _super.prototype.created.call(this);
        this.validate(true);
    };
    Object.defineProperty(EntryText.prototype, "isReadonly", {
        // Generated properties
        get: function () {
            return this.readonly || this.locked || (this.$form && this.$form.readonly);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryText.prototype, "cellClassName", {
        get: function () {
            var c = this.size ? "c-entry-text-" + this.size : "c-entry-text";
            return c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryText.prototype, "entryClassName", {
        get: function () {
            var d = {
                "entry-text": true,
                "no-label": !this.label,
                "highlight": this.hasFocus,
                "mandatory": this.mandatory,
                "readonly": this.isReadonly,
                "locked": this.locked,
                "error": this.showErrors && !this.valid && !this.hasFocus,
                "error-indicator": !this.valid
            };
            if (this.variant) {
                d['entry-text--' + this.variant] = true;
            }
            return d;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryText.prototype, "entryId", {
        get: function () {
            return this.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryText.prototype, "hasValue", {
        get: function () {
            return !!this.value.trim();
        },
        enumerable: true,
        configurable: true
    });
    // Events
    EntryText.prototype.onFocus = function (isFocus) {
        if (isFocus) {
            this.focusValue = this.value;
            this.showErrors = false;
        }
        else {
            this.validate();
            this.showErrors = true;
            if (this.value !== this.focusValue) {
                this.$emit("change", this.fromValue(this.value));
            }
        }
        this.hasFocus = isFocus;
    };
    EntryText.prototype.onInput = function (evt) {
        if (evt.target instanceof HTMLInputElement) {
            this.value = evt.target.value;
            if (this.emitOnInput) {
                this.$emit("change", this.fromValue(this.value));
            }
            this.validate();
            this.showErrors = true;
        }
    };
    EntryText.prototype.onKeyEnter = function (evt) {
        if (evt.target instanceof HTMLInputElement) {
            if (evt.target.blur) {
                evt.target.blur();
            }
            if (this.submitOnEnter) {
                evt.target.form.dispatchEvent(new Event("submit", { cancelable: true }));
            }
        }
    };
    // Validation
    EntryText.prototype.validate = function (forceEmit) {
        if (forceEmit === void 0) { forceEmit = false; }
        var oldValid = this.valid;
        this.valid = !this.mandatory || !!this.value.trim();
        if (!this.isReadonly && (forceEmit || oldValid !== this.valid)) {
            this.$emit("valid-change", this.valid);
        }
    };
    // Public API
    EntryText.prototype.setValue = function (value) {
        if (value === null || value === undefined) {
            this.value = "";
        }
        else {
            this.value = value.toString();
        }
        this.validate();
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryText.prototype, "name", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryText.prototype, "type", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryText.prototype, "size", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryText.prototype, "variant", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryText.prototype, "label", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryText.prototype, "placeholder", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: "" })
    ], EntryText.prototype, "initialValue", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], EntryText.prototype, "readonly", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], EntryText.prototype, "locked", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], EntryText.prototype, "mandatory", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], EntryText.prototype, "submitOnEnter", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], EntryText.prototype, "emitOnInput", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Watch"])('initialValue')
    ], EntryText.prototype, "onInitialValueChanged", null);
    EntryText = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"])({ model: { prop: 'initialValue', event: 'change' } })
    ], EntryText);
    return EntryText;
}(__WEBPACK_IMPORTED_MODULE_1__form_form_component__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (EntryText);


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__form_form_component__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var EntryTextArea = /** @class */ (function (_super) {
    __extends(EntryTextArea, _super);
    function EntryTextArea() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Data
        _this.value = _this.initialValue;
        _this.valid = false;
        _this.hasFocus = false;
        _this.showErrors = false;
        return _this;
    }
    EntryTextArea.prototype.onInitialValueChanged = function (newValue) {
        this.value = newValue;
        this.validate();
    };
    EntryTextArea.prototype.created = function () {
        _super.prototype.created.call(this);
        this.validate(true);
    };
    Object.defineProperty(EntryTextArea.prototype, "isReadonly", {
        // Generated properties
        get: function () {
            return this.readonly || this.locked || this.$form.readonly;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryTextArea.prototype, "cellClassName", {
        get: function () {
            var c = "c-entry-textarea";
            if (this.variant) {
                c += " c-entry-textarea-" + this.variant;
            }
            return c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryTextArea.prototype, "entryClassName", {
        get: function () {
            var d = {
                "entry-textarea": true,
                "no-label": !this.label,
                "highlight": this.hasFocus,
                "mandatory": this.mandatory,
                "readonly": this.isReadonly,
                "locked": this.locked,
                "error": this.showErrors && !this.valid
            };
            if (this.variant) {
                d['entry-textarea--' + this.variant] = true;
            }
            return d;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryTextArea.prototype, "entryId", {
        get: function () {
            return this.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryTextArea.prototype, "hasValue", {
        get: function () {
            return !!this.value.trim();
        },
        enumerable: true,
        configurable: true
    });
    // Events
    EntryTextArea.prototype.onFocus = function (isFocus) {
        if (isFocus) {
            this.focusValue = this.value;
            this.showErrors = false;
        }
        else {
            this.validate();
            this.showErrors = true;
            if (this.value !== this.focusValue) {
                this.$emit('change', this.value);
            }
        }
        this.hasFocus = isFocus;
    };
    EntryTextArea.prototype.onInput = function (evt) {
        if (evt.target instanceof HTMLTextAreaElement) {
            this.value = evt.target.value;
            this.validate();
            this.showErrors = true;
        }
    };
    // Validation
    EntryTextArea.prototype.validate = function (forceEmit) {
        if (forceEmit === void 0) { forceEmit = false; }
        var oldValid = this.valid;
        this.valid = !this.mandatory || !!this.value.trim();
        if (!this.isReadonly && (forceEmit || oldValid !== this.valid)) {
            this.$emit("valid-change", this.valid);
        }
    };
    // Public API
    EntryTextArea.prototype.setValue = function (value) {
        if (value === null || value === undefined) {
            this.value = "";
        }
        else {
            this.value = value.toString();
        }
        this.validate();
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryTextArea.prototype, "name", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryTextArea.prototype, "variant", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryTextArea.prototype, "label", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryTextArea.prototype, "placeholder", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: "" })
    ], EntryTextArea.prototype, "initialValue", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], EntryTextArea.prototype, "readonly", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], EntryTextArea.prototype, "locked", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], EntryTextArea.prototype, "mandatory", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Watch"])('initialValue')
    ], EntryTextArea.prototype, "onInitialValueChanged", null);
    EntryTextArea = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"])({ model: { prop: 'initialValue', event: 'change' } })
    ], EntryTextArea);
    return EntryTextArea;
}(__WEBPACK_IMPORTED_MODULE_1__form_form_component__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (EntryTextArea);


/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__entry_text_vue__ = __webpack_require__(5);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var EntryPassword = /** @class */ (function (_super) {
    __extends(EntryPassword, _super);
    function EntryPassword() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(EntryPassword.prototype, "cellClassName", {
        get: function () {
            var c = this.size ? "c-entry-password-" + this.size : "c-entry-password";
            return c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryPassword.prototype, "entryClassName", {
        get: function () {
            var d = {
                "entry-password": true,
                "no-label": !this.label,
                "highlight": this.hasFocus,
                "mandatory": this.mandatory,
                "readonly": this.isReadonly,
                "locked": this.locked,
                "error": this.showErrors && !this.valid && !this.hasFocus,
                "error-indicator": !this.valid
            };
            if (this.variant) {
                d['entry-password--' + this.variant] = true;
            }
            return d;
        },
        enumerable: true,
        configurable: true
    });
    EntryPassword = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"])({ model: { prop: 'initialValue', event: 'change' } })
    ], EntryPassword);
    return EntryPassword;
}(__WEBPACK_IMPORTED_MODULE_1__entry_text_vue__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (EntryPassword);


/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__entry_text_vue__ = __webpack_require__(5);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var EntryMail = /** @class */ (function (_super) {
    __extends(EntryMail, _super);
    function EntryMail() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(EntryMail.prototype, "cellClassName", {
        get: function () {
            var c = this.size ? "c-entry-mail-" + this.size : "c-entry-mail";
            return c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryMail.prototype, "entryClassName", {
        get: function () {
            var d = {
                "entry-mail": true,
                "no-label": !this.label,
                "highlight": this.hasFocus,
                "mandatory": this.mandatory,
                "readonly": this.isReadonly,
                "locked": this.locked,
                "error": this.showErrors && !this.valid && !this.hasFocus,
                "error-indicator": !this.valid
            };
            if (this.variant) {
                d['entry-mail--' + this.variant] = true;
            }
            return d;
        },
        enumerable: true,
        configurable: true
    });
    // Validation
    EntryMail.prototype.validate = function (forceEmit) {
        if (forceEmit === void 0) { forceEmit = false; }
        var oldValid = this.valid;
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        this.valid = !this.mandatory || (!!this.value.trim() && (re.test(this.value) || /@localhost$/.test(this.value)));
        if (!this.isReadonly && (forceEmit || oldValid !== this.valid)) {
            this.$emit("valid-change", this.valid);
        }
    };
    EntryMail = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"])({ model: { prop: 'initialValue', event: 'change' } })
    ], EntryMail);
    return EntryMail;
}(__WEBPACK_IMPORTED_MODULE_1__entry_text_vue__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (EntryMail);


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__entry_text_vue__ = __webpack_require__(5);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var EntryPhone = /** @class */ (function (_super) {
    __extends(EntryPhone, _super);
    function EntryPhone() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(EntryPhone.prototype, "cellClassName", {
        get: function () {
            var c = this.size ? "c-entry-phone-" + this.size : "c-entry-phone";
            return c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryPhone.prototype, "entryClassName", {
        get: function () {
            var d = {
                "entry-phone": true,
                "no-label": !this.label,
                "highlight": this.hasFocus,
                "mandatory": this.mandatory,
                "readonly": this.isReadonly,
                "locked": this.locked,
                "error": this.showErrors && !this.valid && !this.hasFocus,
                "error-indicator": !this.valid
            };
            if (this.variant) {
                d['entry-phone--' + this.variant] = true;
            }
            return d;
        },
        enumerable: true,
        configurable: true
    });
    EntryPhone = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"])({ model: { prop: 'initialValue', event: 'change' } })
    ], EntryPhone);
    return EntryPhone;
}(__WEBPACK_IMPORTED_MODULE_1__entry_text_vue__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (EntryPhone);


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_class_component__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_form_component__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var EntryPnr = /** @class */ (function (_super) {
    __extends(EntryPnr, _super);
    function EntryPnr() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Data
        _this.value1 = "";
        _this.value2 = "";
        _this.value = _this.value1 + _this.value2;
        _this.valid = false;
        _this.hasFocus = false;
        _this.showErrors = false;
        _this.placeholder = 'XXXX';
        return _this;
    }
    EntryPnr.prototype.created = function () {
        _super.prototype.created.call(this);
        this.validate(true);
    };
    Object.defineProperty(EntryPnr.prototype, "isReadonly", {
        // Generated properties
        get: function () {
            return this.readonly || this.locked || this.$form.readonly;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryPnr.prototype, "entryClassName", {
        get: function () {
            var d = {
                "entry-pnr": true,
                "no-label": !this.label,
                "highlight": this.hasFocus,
                "mandatory": this.mandatory,
                "readonly": this.isReadonly,
                "locked": this.locked,
                "error": this.showErrors && !this.valid
            };
            if (this.variant) {
                d['entry-pnr--' + this.variant] = true;
            }
            return d;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryPnr.prototype, "entryId", {
        get: function () {
            return this.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryPnr.prototype, "hasValue1", {
        get: function () {
            return !!this.value1;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryPnr.prototype, "hasValue2", {
        get: function () {
            return !!this.value2;
        },
        enumerable: true,
        configurable: true
    });
    // Events
    EntryPnr.prototype.onFocus = function (isFocus) {
        if (isFocus) {
            this.focusValue = this.value;
            this.showErrors = false;
        }
        else {
            this.validate();
            this.showErrors = true;
            if (this.value !== this.focusValue) {
                this.$form.$emit("change", { target: this, name: this.name, value: this.value });
            }
        }
        this.hasFocus = isFocus;
    };
    EntryPnr.prototype.onPaste = function (evt) {
        var clipboardData;
        var pastedData;
        evt.stopPropagation();
        evt.preventDefault();
        clipboardData = evt.clipboardData /* || window.clipboardData */;
        pastedData = clipboardData.getData('Text');
    };
    EntryPnr.prototype.onInput1 = function (evt) {
        if (evt.target instanceof HTMLInputElement) {
            this.value1 = evt.target.value.toUpperCase();
            var inputMaxLength = evt.target.maxLength;
            var valueLength = evt.target.value.length;
            if (valueLength >= inputMaxLength) {
                var next = evt.target;
                while (next = next.nextElementSibling) {
                    if (next == null) {
                        break;
                    }
                    if (next.tagName.toLowerCase() === 'input') {
                        next.focus();
                        break;
                    }
                }
            }
            /* this.validate();
            this.showErrors = true; */
        }
    };
    EntryPnr.prototype.onInput2 = function (evt) {
        if (evt.target instanceof HTMLInputElement) {
            this.value2 = evt.target.value.toUpperCase();
            var inputMaxLength = evt.target.maxLength;
            var valueLength = evt.target.value.length;
            if (valueLength === 0) {
                var previous = evt.target;
                while (previous = previous.previousElementSibling) {
                    if (previous == null)
                        break;
                    if (previous.tagName.toLowerCase() === "input") {
                        previous.focus();
                        break;
                    }
                }
            }
            /* this.validate();
            this.showErrors = true; */
        }
    };
    EntryPnr.prototype.onKeyEnter = function (evt) {
        if (evt.target instanceof HTMLInputElement) {
            this.$refs.input.blur();
            if (this.submitOnEnter) {
                evt.target.form.dispatchEvent(new Event("submit", { cancelable: true }));
            }
        }
    };
    // Validation
    EntryPnr.prototype.validate = function (forceEmit) {
        if (forceEmit === void 0) { forceEmit = false; }
        var oldValid = this.valid;
        this.valid = !this.mandatory || !!this.value.trim();
        if (!this.isReadonly && (forceEmit || oldValid !== this.valid)) {
            this.$form.$emit("valid-change", { target: this, name: this.name, value: this.valid });
        }
    };
    // Public API
    EntryPnr.prototype.setValue = function (value) {
        if (value === null || value === undefined) {
            this.value = "";
        }
        else {
            this.value = value.toString();
        }
        this.validate();
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryPnr.prototype, "name", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryPnr.prototype, "initialValue", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryPnr.prototype, "variant", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryPnr.prototype, "label", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryPnr.prototype, "readonly", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryPnr.prototype, "locked", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryPnr.prototype, "mandatory", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryPnr.prototype, "submitOnEnter", void 0);
    EntryPnr = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_class_component___default.a
    ], EntryPnr);
    return EntryPnr;
}(__WEBPACK_IMPORTED_MODULE_2__form_form_component__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (EntryPnr);


/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_class_component__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_form_component__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var EntryEuro = /** @class */ (function (_super) {
    __extends(EntryEuro, _super);
    function EntryEuro() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Data
        _this.value = (_this.initialValue || "").toString();
        _this.valid = false;
        _this.hasFocus = false;
        _this.showErrors = false;
        return _this;
    }
    EntryEuro.prototype.created = function () {
        _super.prototype.created.call(this);
        this.validate(true);
    };
    Object.defineProperty(EntryEuro.prototype, "isReadonly", {
        // Generated properties
        get: function () {
            return this.readonly || this.locked || this.$form.readonly;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryEuro.prototype, "cellClassName", {
        get: function () {
            var c = this.size ? "c-entry-euro-" + this.size : "c-entry-euro";
            return c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryEuro.prototype, "entryClassName", {
        get: function () {
            var d = {
                "entry-euro": true,
                "no-label": !this.label,
                "highlight": this.hasFocus,
                "mandatory": this.mandatory,
                "readonly": this.isReadonly,
                "locked": this.locked,
                "error": this.showErrors && !this.valid
            };
            if (this.variant) {
                d['entry-euro--' + this.variant] = true;
            }
            return d;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryEuro.prototype, "entryId", {
        get: function () {
            return this.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryEuro.prototype, "hasValue", {
        get: function () {
            return !!this.value;
        },
        enumerable: true,
        configurable: true
    });
    // Events
    EntryEuro.prototype.onFocus = function (isFocus) {
        if (isFocus) {
            this.focusValue = this.value;
            this.showErrors = false;
        }
        else {
            this.validate();
            this.showErrors = true;
            if (this.value !== this.focusValue) {
                this.$form.$emit("change", { target: this, name: this.name, value: this.value });
            }
        }
        this.hasFocus = isFocus;
    };
    EntryEuro.prototype.onInput = function (evt) {
        if (evt.target instanceof HTMLInputElement) {
            this.value = evt.target.value;
            this.validate();
            this.showErrors = true;
        }
    };
    EntryEuro.prototype.onKeyEnter = function (evt) {
        if (evt.target instanceof HTMLInputElement) {
            this.$refs.input.blur();
            if (this.submitOnEnter) {
                evt.target.form.dispatchEvent(new Event("submit", { cancelable: true }));
            }
        }
    };
    // Validation
    EntryEuro.prototype.validate = function (forceEmit) {
        if (forceEmit === void 0) { forceEmit = false; }
        var oldValid = this.valid;
        this.valid = !this.mandatory || !!this.value.trim();
        if (!this.isReadonly && (forceEmit || oldValid !== this.valid)) {
            this.$form.$emit("valid-change", { target: this, name: this.name, value: this.valid });
        }
    };
    // Public API
    EntryEuro.prototype.setValue = function (value) {
        if (value === null || value === undefined) {
            this.value = "";
        }
        else {
            this.value = value.toString();
        }
        this.validate();
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryEuro.prototype, "name", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryEuro.prototype, "initialValue", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryEuro.prototype, "size", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryEuro.prototype, "variant", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryEuro.prototype, "label", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryEuro.prototype, "placeholder", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryEuro.prototype, "readonly", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryEuro.prototype, "locked", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryEuro.prototype, "mandatory", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryEuro.prototype, "submitOnEnter", void 0);
    EntryEuro = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_class_component___default.a
    ], EntryEuro);
    return EntryEuro;
}(__WEBPACK_IMPORTED_MODULE_2__form_form_component__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (EntryEuro);


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__entry_text_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_dom__ = __webpack_require__(4);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var EntryColor = /** @class */ (function (_super) {
    __extends(EntryColor, _super);
    function EntryColor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Data
        _this.showColorPicker = false;
        return _this;
    }
    Object.defineProperty(EntryColor.prototype, "entryClassName", {
        // Generated properties
        get: function () {
            var d = {
                "entry-color": true,
                "lite": this.lite,
                "no-label": !this.label,
                "highlight": this.hasFocus,
                "mandatory": this.mandatory,
                "readonly": this.isReadonly,
                "locked": this.locked,
                "error": this.showErrors && !this.valid && !this.hasFocus,
                "error-indicator": !this.valid
            };
            if (this.variant) {
                d['entry-color--' + this.variant] = true;
            }
            return d;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryColor.prototype, "selectedColor", {
        get: function () {
            return "background-color:" + this.value;
        },
        enumerable: true,
        configurable: true
    });
    // Events
    EntryColor.prototype.onShowColorPicker = function () {
        var _this = this;
        if (!this.lite) {
            if (!this.showColorPicker) {
                if (!this.hasFocus) {
                    this.onFocus(true);
                }
                this.showColorPicker = true;
            }
            else {
                this.showColorPicker = false;
            }
            Object(__WEBPACK_IMPORTED_MODULE_2__lib_dom__["b" /* E */])(document).once('click', function (evt) {
                if (evt.target instanceof HTMLElement && !Object(__WEBPACK_IMPORTED_MODULE_2__lib_dom__["a" /* D */])(evt.target).inside(_this.$el)) {
                    _this.showColorPicker = false;
                    return true;
                }
                return false;
            });
        }
    };
    // Validation
    EntryColor.prototype.validate = function (forceEmit) {
        if (forceEmit === void 0) { forceEmit = false; }
        var oldValid = this.valid;
        var re = /^(#?([a-f\d]{3}|[a-f\d]{6})|rgb\((0|255|25[0-4]|2[0-4]\d|1\d\d|0?\d?\d),(0|255|25[0-4]|2[0-4]\d|1\d\d|0?\d?\d),(0|255|25[0-4]|2[0-4]\d|1\d\d|0?\d?\d)\)|rgba\((0|255|25[0-4]|2[0-4]\d|1\d\d|0?\d?\d),(0|255|25[0-4]|2[0-4]\d|1\d\d|0?\d?\d),(0|255|25[0-4]|2[0-4]\d|1\d\d|0?\d?\d),(0?\.\d|1(\.0)?)\)|hsl\((0|360|35\d|3[0-4]\d|[12]\d\d|0?\d?\d),(0|100|\d{1,2})%,(0|100|\d{1,2})%\)|hsla\((0|360|35\d|3[0-4]\d|[12]\d\d|0?\d?\d),(0|100|\d{1,2})%,(0|100|\d{1,2})%,(0?\.\d|1(\.0)?)\))$/;
        this.valid = !!this.value.trim() && re.test(this.value);
        if (!this.isReadonly && (forceEmit || oldValid !== this.valid)) {
            this.$emit("valid-change", this.valid);
        }
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: true })
    ], EntryColor.prototype, "lite", void 0);
    EntryColor = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"])({ model: { prop: 'initialValue', event: 'change' } })
    ], EntryColor);
    return EntryColor;
}(__WEBPACK_IMPORTED_MODULE_1__entry_text_vue__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (EntryColor);


/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var ColorPicker = /** @class */ (function (_super) {
    __extends(ColorPicker, _super);
    function ColorPicker() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ColorPicker = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], ColorPicker);
    return ColorPicker;
}(__WEBPACK_IMPORTED_MODULE_0_vue___default.a));
/* harmony default export */ __webpack_exports__["a"] = (ColorPicker);


/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_form_component__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var EntrySelect = /** @class */ (function (_super) {
    __extends(EntrySelect, _super);
    function EntrySelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Data
        _this.value = _this.initialValue !== null && _this.initialValue !== undefined ? _this.initialValue.toString() : '';
        _this.valid = false;
        _this.hasFocus = false;
        _this.showErrors = false;
        return _this;
    }
    EntrySelect.prototype.onInitialValueChanged = function (newValue) {
        this.value = newValue !== null && newValue !== undefined ? newValue.toString() : '';
        this.validate();
    };
    EntrySelect.prototype.fromValue = function (value) {
        switch (this.type) {
            case 'boolean':
                if (value != '') {
                    return (/true/i).test(value);
                }
                return null;
            case 'number':
                return !!value && parseInt(value) || null;
            default:
                return value || null;
        }
    };
    EntrySelect.prototype.created = function () {
        _super.prototype.created.call(this);
        this.domOptions = Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils__["a" /* extractOptions */])(this.$slots.default);
        this.validate(true);
    };
    Object.defineProperty(EntrySelect.prototype, "isReadonly", {
        // Generated properties
        get: function () {
            return this.readonly || this.locked || this.$form.readonly;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntrySelect.prototype, "cellClassName", {
        get: function () {
            var c = this.size ? "c-entry-select-" + this.size : "c-entry-select";
            return c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntrySelect.prototype, "entryClassName", {
        get: function () {
            var d = {
                "entry-select": true,
                "no-label": !this.label,
                "highlight": this.hasFocus,
                "mandatory": this.mandatory,
                "readonly": this.isReadonly,
                "locked": this.locked,
                "error": this.showErrors && !this.valid
            };
            if (this.variant) {
                d['entry-select--' + this.variant] = true;
            }
            return d;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntrySelect.prototype, "entryId", {
        get: function () {
            return this.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntrySelect.prototype, "optionItems", {
        get: function () {
            if (this.domOptions && this.options) {
                return this.domOptions.concat(this.options);
            }
            return this.options || this.domOptions;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntrySelect.prototype, "displayValue", {
        get: function () {
            var _this = this;
            var option = this.optionItems.filter(function (x) { return x.value == _this.value; });
            return (option.length === 1 && option[0].label) || "";
        },
        enumerable: true,
        configurable: true
    });
    // Events
    EntrySelect.prototype.onChange = function (evt) {
        if (evt.target instanceof HTMLSelectElement) {
            this.value = evt.target.value;
            this.showErrors = true;
            this.validate();
            this.$emit("change", this.fromValue(this.value));
            if (this.submitOnChange) {
                evt.target.form.dispatchEvent(new Event("submit", { cancelable: true }));
            }
            evt.target.blur();
        }
    };
    // Validation
    EntrySelect.prototype.validate = function (forceEmit) {
        if (forceEmit === void 0) { forceEmit = false; }
        var oldValid = this.valid;
        this.valid = !this.mandatory || !!this.value.trim();
        if (!this.isReadonly && (forceEmit || oldValid !== this.valid)) {
            this.$emit("valid-change", this.valid);
        }
    };
    // Public API
    EntrySelect.prototype.setValue = function (value) {
        this.value = value !== null && value !== undefined ? value.toString() : '';
        this.validate();
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntrySelect.prototype, "name", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntrySelect.prototype, "type", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntrySelect.prototype, "size", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntrySelect.prototype, "variant", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntrySelect.prototype, "label", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntrySelect.prototype, "options", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: "" })
    ], EntrySelect.prototype, "initialValue", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], EntrySelect.prototype, "readonly", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], EntrySelect.prototype, "locked", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], EntrySelect.prototype, "mandatory", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], EntrySelect.prototype, "submitOnChange", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Watch"])('initialValue')
    ], EntrySelect.prototype, "onInitialValueChanged", null);
    EntrySelect = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"])({ model: { prop: 'initialValue', event: 'change' } })
    ], EntrySelect);
    return EntrySelect;
}(__WEBPACK_IMPORTED_MODULE_2__form_form_component__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (EntrySelect);


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_form_component__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var EntryCheckboxGroup = /** @class */ (function (_super) {
    __extends(EntryCheckboxGroup, _super);
    function EntryCheckboxGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Data
        _this.value = _this.toValue(_this.initialValue);
        _this.valid = false;
        return _this;
    }
    EntryCheckboxGroup.prototype.onInitialValueChanged = function (newValue) {
        this.value = this.toValue(newValue);
        this.validate();
    };
    EntryCheckboxGroup.prototype.toValue = function (initialValue) {
        if (initialValue && initialValue.map) {
            return initialValue.map(function (x) { return x.toString(); });
        }
        return [];
    };
    EntryCheckboxGroup.prototype.fromValue = function (value) {
        switch (this.type) {
            case 'boolean':
                return !!value && (/true/i).test(value) || null;
            case 'number':
                return !!value && parseInt(value) || null;
            default:
                return value;
        }
    };
    EntryCheckboxGroup.prototype.created = function () {
        _super.prototype.created.call(this);
        this.domOptions = Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils__["a" /* extractOptions */])(this.$slots.default);
        this.validate(true);
    };
    Object.defineProperty(EntryCheckboxGroup.prototype, "cellClassName", {
        // Generated properties.
        get: function () {
            var c = "c-entry-checkbox-group";
            if (this.size && parseInt(this.size) <= 6) {
                c = "c-entry-checkbox-group-6";
            }
            return c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryCheckboxGroup.prototype, "entryClassName", {
        get: function () {
            var c = this.items ? "entry-checkbox-group-" + this.items : "entry-checkbox-group";
            if (this.variant) {
                c += "entry-checkbox-group--" + this.variant;
            }
            return c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryCheckboxGroup.prototype, "optionItems", {
        get: function () {
            return this.options || this.domOptions;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryCheckboxGroup.prototype, "hasValue", {
        get: function () {
            return !!this.value;
        },
        enumerable: true,
        configurable: true
    });
    EntryCheckboxGroup.prototype.getId = function (item) {
        return this.name + "_" + item.value;
    };
    // Events
    EntryCheckboxGroup.prototype.onChange = function (evt) {
        var _this = this;
        if (evt.target instanceof HTMLInputElement) {
            var value_1 = evt.target.value;
            if (evt.target.checked) {
                this.value.push(value_1);
            }
            else {
                this.value = this.value.filter(function (x) { return x != value_1; });
            }
            // Map current values to correct type.
            var values = this.value.filter(function (x) { return x != ''; }).map(function (x) { return _this.fromValue(x); });
            this.$emit("change", values.length > 0 ? values : null);
        }
    };
    // Validation
    EntryCheckboxGroup.prototype.validate = function (forceEmit) {
        if (forceEmit === void 0) { forceEmit = false; }
        var oldValid = this.valid;
        this.valid = !this.mandatory || this.value.length > 0;
        if (forceEmit || oldValid !== this.valid) {
            this.$form.$emit("valid-change", this.valid);
        }
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryCheckboxGroup.prototype, "name", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryCheckboxGroup.prototype, "type", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryCheckboxGroup.prototype, "size", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryCheckboxGroup.prototype, "variant", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryCheckboxGroup.prototype, "items", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryCheckboxGroup.prototype, "label", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryCheckboxGroup.prototype, "options", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: null })
    ], EntryCheckboxGroup.prototype, "initialValue", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], EntryCheckboxGroup.prototype, "mandatory", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Watch"])('initialValue')
    ], EntryCheckboxGroup.prototype, "onInitialValueChanged", null);
    EntryCheckboxGroup = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"])({ model: { prop: 'initialValue', event: 'change' } })
    ], EntryCheckboxGroup);
    return EntryCheckboxGroup;
}(__WEBPACK_IMPORTED_MODULE_2__form_form_component__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (EntryCheckboxGroup);


/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_form_component__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var EntryRadioGroup = /** @class */ (function (_super) {
    __extends(EntryRadioGroup, _super);
    function EntryRadioGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Data
        _this.value = _this.initialValue != null ? _this.initialValue.toString() : '';
        _this.valid = false;
        return _this;
        // Public API
    }
    EntryRadioGroup.prototype.onInitialValueChanged = function (newValue) {
        this.value = newValue != null ? newValue.toString() : '';
        this.validate();
    };
    EntryRadioGroup.prototype.fromValue = function (value) {
        switch (this.type) {
            case 'boolean':
                if (value != '') {
                    return (/true/i).test(value);
                }
                return null;
            case 'number':
                return !!value && parseInt(value) || null;
            default:
                return value || null;
        }
    };
    EntryRadioGroup.prototype.created = function () {
        _super.prototype.created.call(this);
        this.domOptions = Object(__WEBPACK_IMPORTED_MODULE_1__lib_utils__["a" /* extractOptions */])(this.$slots.default);
        this.validate(true);
    };
    Object.defineProperty(EntryRadioGroup.prototype, "cellClassName", {
        // Generated properties
        get: function () {
            var c = "c-entry-radio-group";
            if (this.size && parseInt(this.size) <= 6) {
                c = "c-entry-radio-group-6";
            }
            return c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryRadioGroup.prototype, "entryClassName", {
        get: function () {
            var c = this.items ? "entry-radio-group-" + this.items : "entry-radio-group";
            if (this.variant) {
                c += " entry-radio-group--" + this.variant;
            }
            return c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryRadioGroup.prototype, "optionItems", {
        get: function () {
            return this.options || this.domOptions;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryRadioGroup.prototype, "hasValue", {
        get: function () {
            return !!this.value;
        },
        enumerable: true,
        configurable: true
    });
    EntryRadioGroup.prototype.getId = function (item) {
        return this.name + "_" + item.value;
    };
    // Events
    EntryRadioGroup.prototype.onChange = function (evt) {
        if (evt.target instanceof HTMLInputElement) {
            this.value = evt.target.value;
            this.$emit("change", this.fromValue(this.value));
        }
    };
    // Validation
    EntryRadioGroup.prototype.validate = function (forceEmit) {
        if (forceEmit === void 0) { forceEmit = false; }
        var oldValid = this.valid;
        this.valid = !this.mandatory || (!!this.value && !!this.value.trim());
        if (forceEmit || oldValid !== this.valid) {
            this.$emit("valid-change", this.valid);
        }
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryRadioGroup.prototype, "name", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryRadioGroup.prototype, "type", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryRadioGroup.prototype, "size", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryRadioGroup.prototype, "variant", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryRadioGroup.prototype, "items", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryRadioGroup.prototype, "label", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryRadioGroup.prototype, "options", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: "" })
    ], EntryRadioGroup.prototype, "initialValue", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], EntryRadioGroup.prototype, "mandatory", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Watch"])('initialValue')
    ], EntryRadioGroup.prototype, "onInitialValueChanged", null);
    EntryRadioGroup = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"])({ model: { prop: 'initialValue', event: 'change' } })
    ], EntryRadioGroup);
    return EntryRadioGroup;
}(__WEBPACK_IMPORTED_MODULE_2__form_form_component__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (EntryRadioGroup);


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_dom__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_form_component__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var EntryDate = /** @class */ (function (_super) {
    __extends(EntryDate, _super);
    function EntryDate() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Data
        _this.value = "";
        _this.displayValue = "";
        _this.valid = false;
        _this.hasFocus = 0;
        _this.showCalendar = false;
        _this.showErrors = false;
        return _this;
    }
    EntryDate.prototype.onInitialValueChanged = function (newValue) {
        this.setValue(this.initialValue);
        this.validate(true);
    };
    EntryDate.prototype.created = function () {
        _super.prototype.created.call(this);
        if (this.format && /L(L{0,3}|T|TS)/.test(this.format)) {
            this.parseFormat = __WEBPACK_IMPORTED_MODULE_0_moment___default.a.localeData().longDateFormat(this.format);
        }
        this.setValue(this.initialValue);
        this.validate(true);
    };
    Object.defineProperty(EntryDate.prototype, "isReadonly", {
        // Generated properties.
        get: function () {
            return this.readonly || this.locked || (this.$form && this.$form.readonly);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryDate.prototype, "cellClassName", {
        get: function () {
            var c = this.size ? "c-entry-date-" + this.size : "c-entry-date";
            return c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryDate.prototype, "entryClassName", {
        get: function () {
            var d = {
                "entry-date": true,
                "no-label": !this.label,
                "highlight": this.hasFocus > 0,
                "mandatory": this.mandatory,
                "readonly": this.isReadonly,
                "locked": this.locked,
                "error": this.showErrors && !this.valid
            };
            if (this.variant) {
                d['entry-date--' + this.variant] = true;
            }
            return d;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryDate.prototype, "entryId", {
        get: function () {
            return this.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryDate.prototype, "hasValue", {
        get: function () {
            return !!this.value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryDate.prototype, "hasDisplayValue", {
        get: function () {
            return !!this.displayValue;
        },
        enumerable: true,
        configurable: true
    });
    // Events
    EntryDate.prototype.prevDay = function () {
        this.setValue(__WEBPACK_IMPORTED_MODULE_0_moment___default()(this.value).subtract(1, 'day').format('YYYY-MM-DD'));
        this.$emit("change", this.value);
    };
    EntryDate.prototype.nextDay = function () {
        this.setValue(__WEBPACK_IMPORTED_MODULE_0_moment___default()(this.value).add(1, 'day').format('YYYY-MM-DD'));
        this.$emit("change", this.value);
    };
    EntryDate.prototype.onInput = function (evt) {
        if (evt.target instanceof HTMLInputElement) {
            this.setValue(evt.target.value, true);
        }
    };
    EntryDate.prototype.onPickerChange = function (evt) {
        this.showCalendar = false;
        if (this.value !== evt.value) {
            this.setValue(evt.value);
            this.$emit("change", this.value);
        }
    };
    EntryDate.prototype.onShowCalendar = function () {
        var _this = this;
        if (!this.showCalendar) {
            this.showErrors = false;
            this.showCalendar = true;
        }
        else {
            this.showCalendar = false;
        }
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_dom__["b" /* E */])(document).once('click', function (evt) {
            if (evt.target instanceof HTMLElement && !Object(__WEBPACK_IMPORTED_MODULE_2__lib_dom__["a" /* D */])(evt.target).inside(_this.$el)) {
                _this.showCalendar = false;
                return true;
            }
            return false;
        });
    };
    EntryDate.prototype.onFocus = function (focus) {
        if (focus > 0) {
            this.focusValue = this.value;
            this.showErrors = false;
        }
        else {
            if (!this.showCalendar) {
                this.showErrors = true;
                if (this.value != this.focusValue) {
                    this.$emit("change", this.value);
                }
            }
        }
        this.hasFocus = focus;
    };
    // Validation
    EntryDate.prototype.validate = function (forceEmit) {
        if (forceEmit === void 0) { forceEmit = false; }
        var oldValid = this.valid;
        if (this.value.trim()) {
            var m = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.value, 'YYYY-MM-DD');
            this.valid = m.isValid() && m.isAfter(__WEBPACK_IMPORTED_MODULE_0_moment___default()("1200-01-01", 'YYYY-MM-DD'));
        }
        else {
            this.valid = !this.mandatory;
        }
        if (!this.isReadonly && (forceEmit || oldValid !== this.valid)) {
            this.$emit("valid-change", this.valid);
        }
    };
    // Public API
    EntryDate.prototype.parseDate = function (value) {
        var date;
        if (this.parseFormat) {
            date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(value, this.parseFormat);
        }
        if (!date || !date.isValid()) {
            date = __WEBPACK_IMPORTED_MODULE_0_moment___default()(value, 'YYYY-MM-DD');
        }
        return date;
    };
    EntryDate.prototype.setValue = function (value, isFromInput) {
        if (isFromInput === void 0) { isFromInput = false; }
        if (isFromInput) {
            this.value = "";
            this.displayValue = value;
            if (value) {
                var m = this.parseDate(value);
                if (m.isValid()) {
                    this.value = m.format('YYYY-MM-DD');
                }
            }
        }
        else {
            this.value = value || "";
            if (value) {
                var m = this.parseDate(value);
                if (m.isValid()) {
                    this.displayValue = m.format(this.format);
                }
            }
            else {
                this.displayValue = "";
            }
        }
        this.validate();
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryDate.prototype, "name", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryDate.prototype, "initialValue", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryDate.prototype, "size", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryDate.prototype, "variant", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryDate.prototype, "label", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryDate.prototype, "placeholder", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'L' })
    ], EntryDate.prototype, "format", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryDate.prototype, "readonly", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryDate.prototype, "locked", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryDate.prototype, "mandatory", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Watch"])('initialValue')
    ], EntryDate.prototype, "onInitialValueChanged", null);
    EntryDate = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({ model: { prop: 'initialValue', event: 'change' } })
    ], EntryDate);
    return EntryDate;
}(__WEBPACK_IMPORTED_MODULE_3__form_form_component__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (EntryDate);


/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_calendar__ = __webpack_require__(36);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var DatePicker = /** @class */ (function (_super) {
    __extends(DatePicker, _super);
    function DatePicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Data
        _this.current = _this.initialValue ? __WEBPACK_IMPORTED_MODULE_1_moment__(_this.initialValue) : __WEBPACK_IMPORTED_MODULE_1_moment__();
        _this.currentYear = _this.current.get('year');
        _this.day = __WEBPACK_IMPORTED_MODULE_1_moment__(_this.initialValue);
        _this.showYears = false;
        _this.showDays = true;
        return _this;
    }
    Object.defineProperty(DatePicker.prototype, "headerYear", {
        // Generated properties
        get: function () {
            return this.current.format("YYYY");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "headerMonth", {
        get: function () {
            return this.current.format("MMM");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "headerDecade", {
        get: function () {
            return Math.floor(this.currentYear / 10) * 10 + ' - ' + (Math.floor(this.currentYear / 10) * 10 + 19);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "calendarWeeks", {
        get: function () {
            var month = this.current.clone().startOf('month');
            var start = month.clone().startOf('week');
            var end = this.current.clone().endOf('month').endOf('week');
            var d = start.clone();
            var weeks = [];
            while (d <= end) {
                var w = [];
                for (var i = 0; i < 7; i++) {
                    w.push(new __WEBPACK_IMPORTED_MODULE_3__lib_calendar__["a" /* CalendarDay */](d.clone(), month, this.day));
                    d.add(1, 'days');
                }
                weeks.push(w);
            }
            return weeks;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "calendarYears", {
        get: function () {
            var years = [];
            var startYear = Math.floor(this.currentYear / 10) * 10;
            for (var i = 0; i < 20; i++) {
                years.push(startYear + i);
            }
            return years;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DatePicker.prototype, "daysNames", {
        get: function () {
            return Object(__WEBPACK_IMPORTED_MODULE_3__lib_calendar__["b" /* generateDaysNames */])(this.current);
        },
        enumerable: true,
        configurable: true
    });
    // Methods and event handlers
    DatePicker.prototype.prevMonth = function () {
        this.current = this.current.clone().subtract(1, 'month');
    };
    DatePicker.prototype.nextMonth = function () {
        this.current = this.current.clone().add(1, 'month');
    };
    DatePicker.prototype.prevDecades = function () {
        this.currentYear = this.currentYear - 20;
    };
    DatePicker.prototype.nextDecades = function () {
        this.currentYear = this.currentYear + 20;
    };
    DatePicker.prototype.setCurrent = function (evt) {
        if (evt.target instanceof HTMLElement) {
            var date = evt.target.getAttribute("data-date");
            if (date && date !== this.current.format("YYYY-MM-DD")) {
                this.current = __WEBPACK_IMPORTED_MODULE_1_moment__(date);
                this.day = __WEBPACK_IMPORTED_MODULE_1_moment__(date);
            }
            this.$emit("change", { target: this, value: date });
        }
    };
    DatePicker.prototype.setCurrentYear = function (evt) {
        if (evt.target instanceof HTMLElement) {
            var year = Number(evt.target.getAttribute("data-year"));
            if (year && year !== this.currentYear) {
                this.currentYear = year;
                this.current = this.current.clone().year(year);
            }
            this.setShowDays();
        }
    };
    DatePicker.prototype.setShowYears = function () {
        this.showYears = true;
        this.showDays = false;
    };
    DatePicker.prototype.setShowDays = function () {
        this.showYears = false;
        this.showDays = true;
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["Prop"])()
    ], DatePicker.prototype, "initialValue", void 0);
    DatePicker = __decorate([
        __WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["Component"]
    ], DatePicker);
    return DatePicker;
}(__WEBPACK_IMPORTED_MODULE_0_vue___default.a));
/* harmony default export */ __webpack_exports__["a"] = (DatePicker);


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CalendarDay; });
/* harmony export (immutable) */ __webpack_exports__["b"] = generateDaysNames;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);

var CalendarDay = /** @class */ (function () {
    function CalendarDay(displayDay, displayMonth, day, dayTo) {
        this.day = displayDay.clone();
        this.dayOfMonth = this.day.format('DD');
        this.isToday = this.day.format('YYYYMMDD') == __WEBPACK_IMPORTED_MODULE_0_moment__().format('YYYYMMDD');
        this.isThisYear = this.day.format('YYYY') == __WEBPACK_IMPORTED_MODULE_0_moment__().format('YYYY');
        this.isoDate = this.day.format('YYYY-MM-DD');
        if (day != null) {
            this.isCurrentDay = this.day.format('YYYYMMDD') == day.format('YYYYMMDD');
            this.isCurrentMonth = (displayMonth.format('YYYYMM') == this.day.format('YYYYMM'));
            this.isPeriodFrom = this.day.format('YYYYMMDD') == day.format('YYYYMMDD');
        }
        if (day != null && dayTo != null && dayTo >= day) {
            this.isPeriodTo = this.day.format('YYYYMMDD') == dayTo.format('YYYYMMDD');
            this.isInPeriod = (this.day >= day) && (this.day <= dayTo);
        }
    }
    return CalendarDay;
}());

function generateDaysNames(now) {
    var names = [];
    var d = now.clone().startOf('week');
    for (var i = 0; i < 7; i++) {
        names.push(d.format('dd'));
        d.add(1, 'day');
    }
    return names;
}


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_dom__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__form_form_component__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var EntryPeriod = /** @class */ (function (_super) {
    __extends(EntryPeriod, _super);
    function EntryPeriod() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Data
        _this.from = "";
        _this.to = "";
        _this.displayFrom = "";
        _this.displayTo = "";
        _this.valid = false;
        _this.hasFocus = 0;
        _this.showCalendar = false;
        _this.showErrors = false;
        return _this;
    }
    EntryPeriod.prototype.created = function () {
        _super.prototype.created.call(this);
        this.setFromValue(this.initialValue && this.initialValue.from);
        this.setToValue(this.initialValue && this.initialValue.to);
        this.validate(true);
    };
    Object.defineProperty(EntryPeriod.prototype, "value", {
        // Generated properties.
        get: function () {
            return { from: this.from, to: this.to };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryPeriod.prototype, "isReadonly", {
        get: function () {
            return this.readonly || this.locked || this.$form.readonly;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryPeriod.prototype, "cellClassName", {
        get: function () {
            var c = this.size ? "c-entry-period-" + this.size : "c-entry-period";
            return c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryPeriod.prototype, "entryClassName", {
        get: function () {
            var d = {
                "entry-period": true,
                "no-label": !this.label,
                "highlight": this.hasFocus > 0,
                "mandatory": this.mandatory,
                "readonly": this.isReadonly,
                "locked": this.locked,
                "error": this.showErrors && !this.valid
            };
            if (this.variant) {
                d['entry-period--' + this.variant] = true;
            }
            return d;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryPeriod.prototype, "input1Name", {
        get: function () {
            return this.nameFrom || (this.name + "From");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryPeriod.prototype, "input2Name", {
        get: function () {
            return this.nameTo || (this.name + "To");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryPeriod.prototype, "entryId", {
        get: function () {
            return this.nameFrom + "__" + this.nameTo;
        },
        enumerable: true,
        configurable: true
    });
    // Events
    EntryPeriod.prototype.onInput1 = function (evt) {
        if (evt.target instanceof HTMLInputElement) {
            this.setFromValue(evt.target.value, true);
        }
    };
    EntryPeriod.prototype.onInput2 = function (evt) {
        if (evt.target instanceof HTMLInputElement) {
            this.setToValue(evt.target.value, true);
        }
    };
    EntryPeriod.prototype.onPickerChangeFrom = function (evt) {
        this.setFromValue(evt.value);
        this.onFocus(2);
    };
    EntryPeriod.prototype.onPickerChangeTo = function (evt) {
        this.showCalendar = false;
        this.setToValue(evt.value);
        this.onFocus(0);
        this.$emit("change", { from: this.from, to: this.to });
    };
    EntryPeriod.prototype.onShowCalendar = function () {
        var _this = this;
        if (!this.showCalendar) {
            if (this.hasFocus === 0) {
                this.onFocus(1);
            }
            this.showCalendar = true;
        }
        else {
            this.showCalendar = false;
        }
        Object(__WEBPACK_IMPORTED_MODULE_2__lib_dom__["b" /* E */])(document).once('click', function (evt) {
            if (evt.target instanceof HTMLElement && !Object(__WEBPACK_IMPORTED_MODULE_2__lib_dom__["a" /* D */])(evt.target).inside(_this.$el)) {
                _this.showCalendar = false;
                return true;
            }
            return false;
        });
    };
    EntryPeriod.prototype.onFocus = function (input) {
        if (input > 0) {
            this.hasFocus = input;
            this.showErrors = false;
        }
        else {
            if (!this.showCalendar) {
                this.hasFocus = 0;
                this.showErrors = true;
            }
        }
    };
    // Validation
    EntryPeriod.prototype.validate = function (forceEmit) {
        if (forceEmit === void 0) { forceEmit = false; }
        var oldValid = this.valid;
        var valid1 = true, valid2 = true;
        if (this.from.trim()) {
            var m = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.from, "YYYY-MM-DD");
            valid1 = m.isValid() && m.isAfter(__WEBPACK_IMPORTED_MODULE_0_moment___default()("1900-1-1", "YYYY-MM-DD"));
        }
        else {
            valid1 = !this.mandatory;
        }
        if (this.to.trim()) {
            var m = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.to, "YYYY-MM-DD");
            valid2 = m.isValid() && m.isAfter(__WEBPACK_IMPORTED_MODULE_0_moment___default()("1900-1-1", "YYYY-MM-DD"));
        }
        else {
            valid2 = !this.mandatory;
        }
        this.valid = valid1 && valid2;
        if (!this.isReadonly && (forceEmit || oldValid !== this.valid)) {
            this.$emit("valid-change", this.valid);
        }
    };
    EntryPeriod.prototype.setFromValue = function (value, isFromInput) {
        if (isFromInput === void 0) { isFromInput = false; }
        if (isFromInput) {
            this.displayFrom = value || "";
            if (value) {
                var m = __WEBPACK_IMPORTED_MODULE_0_moment___default()(value, this.format);
                if (m.isValid()) {
                    this.from = m.format("YYYY-MM-DD");
                }
                else {
                    this.from = "";
                }
            }
            else {
                this.from = "";
            }
        }
        else {
            this.from = value || "";
            if (value) {
                var m = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.from);
                if (m.isValid()) {
                    this.displayFrom = m.format(this.format);
                }
            }
            else {
                this.displayFrom = "";
            }
        }
        this.validate();
    };
    EntryPeriod.prototype.setToValue = function (value, isFromInput) {
        if (isFromInput === void 0) { isFromInput = false; }
        if (isFromInput) {
            this.displayTo = value || "";
            if (value) {
                var m = __WEBPACK_IMPORTED_MODULE_0_moment___default()(value, this.format);
                if (m.isValid()) {
                    this.to = m.format("YYYY-MM-DD");
                }
                else {
                    this.to = "";
                }
            }
            else {
                this.to = "";
            }
        }
        else {
            this.to = value || "";
            if (value) {
                var m = __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.to);
                if (m.isValid()) {
                    this.displayTo = m.format(this.format);
                }
            }
            else {
                this.displayTo = "";
            }
        }
        this.validate();
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryPeriod.prototype, "name", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryPeriod.prototype, "nameFrom", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryPeriod.prototype, "nameTo", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryPeriod.prototype, "initialValue", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryPeriod.prototype, "size", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryPeriod.prototype, "variant", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryPeriod.prototype, "label", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryPeriod.prototype, "labelFrom", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryPeriod.prototype, "labelTo", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: 'L' })
    ], EntryPeriod.prototype, "format", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryPeriod.prototype, "readonly", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryPeriod.prototype, "locked", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryPeriod.prototype, "mandatory", void 0);
    EntryPeriod = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"])({ model: { prop: 'initialValue', event: 'change' } })
    ], EntryPeriod);
    return EntryPeriod;
}(__WEBPACK_IMPORTED_MODULE_3__form_form_component__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (EntryPeriod);


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_calendar__ = __webpack_require__(36);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var PeriodPicker = /** @class */ (function (_super) {
    __extends(PeriodPicker, _super);
    function PeriodPicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Data
        _this.current = _this.initialFromValue ? __WEBPACK_IMPORTED_MODULE_1_moment__(_this.initialFromValue) : __WEBPACK_IMPORTED_MODULE_1_moment__();
        _this.currentYear = _this.current.get('year');
        _this.day = __WEBPACK_IMPORTED_MODULE_1_moment__(_this.initialFromValue);
        _this.dayTo = __WEBPACK_IMPORTED_MODULE_1_moment__(_this.initialToValue);
        _this.showYears = false;
        _this.showDays = true;
        _this.isActivePeriodTo = false;
        return _this;
    }
    Object.defineProperty(PeriodPicker.prototype, "headerDecade", {
        // Generated properties
        get: function () {
            return Math.floor(this.currentYear / 10) * 10 + ' - ' + (Math.floor(this.currentYear / 10) * 10 + 19);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PeriodPicker.prototype, "calendarYears", {
        get: function () {
            var years = [];
            var startYear = Math.floor(this.currentYear / 10) * 10;
            for (var i = 0; i < 20; i++) {
                years.push(startYear + i);
            }
            return years;
        },
        enumerable: true,
        configurable: true
    });
    // Methods and event handlers
    PeriodPicker.prototype.headerYear = function (monthDelta) {
        if (monthDelta === void 0) { monthDelta = 0; }
        return this.current.clone().add(monthDelta, 'months').format("YYYY");
    };
    PeriodPicker.prototype.headerMonth = function (monthDelta) {
        if (monthDelta === void 0) { monthDelta = 0; }
        return this.current.clone().add(monthDelta, 'months').format("MMM");
    };
    PeriodPicker.prototype.calendarWeeks = function (monthDelta) {
        if (monthDelta === void 0) { monthDelta = 0; }
        var month = this.current.clone().add(monthDelta, 'months').startOf('month');
        var start = month.clone().startOf('week');
        var end = month.clone().endOf('month').endOf('week');
        var d = start.clone();
        var weeks = [];
        while (d <= end) {
            var w = [];
            for (var i = 0; i < 7; i++) {
                w.push(new __WEBPACK_IMPORTED_MODULE_3__lib_calendar__["a" /* CalendarDay */](d.clone(), month.clone(), this.day, this.dayTo));
                d.add(1, 'days');
            }
            weeks.push(w);
        }
        return weeks;
    };
    Object.defineProperty(PeriodPicker.prototype, "daysNames", {
        get: function () {
            return Object(__WEBPACK_IMPORTED_MODULE_3__lib_calendar__["b" /* generateDaysNames */])(this.current);
        },
        enumerable: true,
        configurable: true
    });
    PeriodPicker.prototype.prevMonth = function () {
        this.current = this.current.clone().subtract(1, 'month');
    };
    PeriodPicker.prototype.nextMonth = function () {
        this.current = this.current.clone().add(1, 'month');
    };
    PeriodPicker.prototype.prevDecades = function () {
        this.currentYear = this.currentYear - 20;
    };
    PeriodPicker.prototype.nextDecades = function () {
        this.currentYear = this.currentYear + 20;
    };
    PeriodPicker.prototype.setCurrent = function (evt) {
        if (evt.target instanceof HTMLElement) {
            var date = evt.target.getAttribute("data-date");
            if (date) {
                if (this.initialActivePeriodFrom && !this.isActivePeriodTo) {
                    this.current = __WEBPACK_IMPORTED_MODULE_1_moment__(date);
                    this.day = __WEBPACK_IMPORTED_MODULE_1_moment__(date);
                    this.$emit("change-from", { target: this, value: this.day.format("YYYY-MM-DD") });
                    this.isActivePeriodTo = true;
                }
                else {
                    this.dayTo = __WEBPACK_IMPORTED_MODULE_1_moment__(date);
                    this.$emit("change-to", { target: this, value: this.dayTo.format("YYYY-MM-DD") });
                }
            }
        }
    };
    PeriodPicker.prototype.setCurrentYear = function (evt) {
        if (evt.target instanceof HTMLElement) {
            var year = Number(evt.target.getAttribute("data-year"));
            if (year && year !== this.currentYear) {
                this.currentYear = year;
                this.current = this.current.clone().year(year);
            }
            this.setShowDays();
        }
    };
    PeriodPicker.prototype.setShowYears = function () {
        this.showYears = true;
        this.showDays = false;
    };
    PeriodPicker.prototype.setShowDays = function () {
        this.showYears = false;
        this.showDays = true;
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["Prop"])()
    ], PeriodPicker.prototype, "initialFromValue", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["Prop"])()
    ], PeriodPicker.prototype, "initialToValue", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["Prop"])()
    ], PeriodPicker.prototype, "initialActivePeriodFrom", void 0);
    PeriodPicker = __decorate([
        __WEBPACK_IMPORTED_MODULE_2_vue_property_decorator__["Component"]
    ], PeriodPicker);
    return PeriodPicker;
}(__WEBPACK_IMPORTED_MODULE_0_vue___default.a));
/* harmony default export */ __webpack_exports__["a"] = (PeriodPicker);


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_class_component__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_form_component__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_dom__ = __webpack_require__(4);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var EntryImage = /** @class */ (function (_super) {
    __extends(EntryImage, _super);
    function EntryImage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Data
        _this.value = (_this.initialValue || "").toString();
        _this.valid = false;
        _this.hasFocus = 0;
        _this.showErrors = false;
        _this.showImagePicker = false;
        return _this;
    }
    EntryImage.prototype.created = function () {
        _super.prototype.created.call(this);
        this.validate(true);
    };
    Object.defineProperty(EntryImage.prototype, "isReadonly", {
        // Generated properties
        get: function () {
            return this.readonly || this.locked || this.$form.readonly;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryImage.prototype, "entryClassName", {
        get: function () {
            var d = {
                "entry-image": true,
                "no-label": !this.label,
                "highlight": this.hasFocus,
                "mandatory": this.mandatory,
                "readonly": this.isReadonly,
                "locked": this.locked,
                "error": this.showErrors && !this.valid
            };
            if (this.variant) {
                d['entry-image--' + this.variant] = true;
            }
            return d;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryImage.prototype, "entryId", {
        get: function () {
            return this.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryImage.prototype, "hasValue", {
        get: function () {
            return !!this.value;
        },
        enumerable: true,
        configurable: true
    });
    // Events
    EntryImage.prototype.onFocus = function (input) {
        if (input > 0) {
            this.hasFocus = input;
            this.showErrors = false;
        }
        else {
            if (!this.showImagePicker) {
                this.hasFocus = 0;
                this.showErrors = true;
            }
        }
    };
    EntryImage.prototype.onShowImagePicker = function () {
        var _this = this;
        if (!this.showImagePicker) {
            if (this.hasFocus === 0) {
                this.onFocus(1);
            }
            this.showImagePicker = true;
        }
        else {
            this.showImagePicker = false;
        }
        Object(__WEBPACK_IMPORTED_MODULE_3__lib_dom__["b" /* E */])(document).once('click', function (evt) {
            if (evt.target instanceof HTMLElement && !Object(__WEBPACK_IMPORTED_MODULE_3__lib_dom__["a" /* D */])(evt.target).inside(_this.$el)) {
                _this.showImagePicker = false;
                return true;
            }
            return false;
        });
    };
    // Validation
    EntryImage.prototype.validate = function (forceEmit) {
        if (forceEmit === void 0) { forceEmit = false; }
        var oldValid = this.valid;
        this.valid = !this.mandatory || !!this.value.trim();
        if (!this.isReadonly && (forceEmit || oldValid !== this.valid)) {
            this.$form.$emit("valid-change", { target: this, name: this.name, value: this.valid });
        }
    };
    // Public API
    EntryImage.prototype.setValue = function (value) {
        if (value === null || value === undefined) {
            this.value = "";
        }
        else {
            this.value = value.toString();
        }
        this.validate();
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryImage.prototype, "name", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryImage.prototype, "initialValue", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryImage.prototype, "size", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryImage.prototype, "variant", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryImage.prototype, "label", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryImage.prototype, "placeholder", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryImage.prototype, "readonly", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryImage.prototype, "locked", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryImage.prototype, "mandatory", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryImage.prototype, "submitOnEnter", void 0);
    EntryImage = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_class_component___default.a
    ], EntryImage);
    return EntryImage;
}(__WEBPACK_IMPORTED_MODULE_2__form_form_component__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (EntryImage);


/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var ImagePicker = /** @class */ (function (_super) {
    __extends(ImagePicker, _super);
    function ImagePicker() {
        // Data
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.image = '';
        _this.actionBrowseHover = false;
        return _this;
    }
    // Events
    ImagePicker.prototype.onFileChange = function (e) {
        var files = e.target.files || e.dataTransfer.files;
        if (!files.length)
            return;
        this.createImage(files[0]);
    };
    ImagePicker.prototype.createImage = function (file) {
        var _this = this;
        var image = new Image();
        var reader = new FileReader();
        reader.onload = function (e) {
            _this.image = e.target.result;
        };
        reader.readAsDataURL(file);
    };
    ImagePicker.prototype.removeImage = function (e) {
        this.image = '';
    };
    ImagePicker = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], ImagePicker);
    return ImagePicker;
}(__WEBPACK_IMPORTED_MODULE_0_vue___default.a));
/* harmony default export */ __webpack_exports__["a"] = (ImagePicker);


/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_class_component__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_form_component__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};



var EntryTime = /** @class */ (function (_super) {
    __extends(EntryTime, _super);
    function EntryTime() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Data
        _this.value = (_this.initialValue || "").toString();
        _this.valid = false;
        _this.hasFocus = false;
        _this.showErrors = false;
        return _this;
    }
    EntryTime.prototype.created = function () {
        _super.prototype.created.call(this);
        this.validate(true);
    };
    Object.defineProperty(EntryTime.prototype, "isReadonly", {
        // Generated properties
        get: function () {
            return this.readonly || this.locked || this.$form.readonly;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryTime.prototype, "cellClassName", {
        get: function () {
            var c = this.size ? "c-entry-time-" + this.size : "c-entry-time";
            return c;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryTime.prototype, "entryClassName", {
        get: function () {
            var d = {
                "entry-time": true,
                "no-label": !this.label,
                "highlight": this.hasFocus,
                "mandatory": this.mandatory,
                "readonly": this.isReadonly,
                "locked": this.locked,
                "error": this.showErrors && !this.valid
            };
            if (this.variant) {
                d['entry-time--' + this.variant] = true;
            }
            return d;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryTime.prototype, "entryId", {
        get: function () {
            return this.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryTime.prototype, "hasValue", {
        get: function () {
            return !!this.value;
        },
        enumerable: true,
        configurable: true
    });
    // Events
    EntryTime.prototype.onFocus = function (isFocus) {
        if (isFocus) {
            this.focusValue = this.value;
            this.showErrors = false;
        }
        else {
            this.validate();
            this.showErrors = true;
            if (this.value !== this.focusValue) {
                this.$form.$emit("change", { target: this, name: this.name, value: this.value });
            }
        }
        this.hasFocus = isFocus;
    };
    EntryTime.prototype.onInput = function (evt) {
        if (evt.target instanceof HTMLInputElement) {
            this.value = evt.target.value;
            this.validate();
            this.showErrors = true;
        }
    };
    EntryTime.prototype.onKeyEnter = function (evt) {
        if (evt.target instanceof HTMLInputElement) {
            this.$refs.input.blur();
            if (this.submitOnEnter) {
                evt.target.form.dispatchEvent(new Event("submit", { cancelable: true }));
            }
        }
    };
    // Validation
    EntryTime.prototype.validate = function (forceEmit) {
        if (forceEmit === void 0) { forceEmit = false; }
        var oldValid = this.valid;
        this.valid = !this.mandatory || !!this.value.trim();
        if (!this.isReadonly && (forceEmit || oldValid !== this.valid)) {
            this.$form.$emit("valid-change", { target: this, name: this.name, value: this.valid });
        }
    };
    // Public API
    EntryTime.prototype.setValue = function (value) {
        if (value === null || value === undefined) {
            this.value = "";
        }
        else {
            this.value = value.toString();
        }
        this.validate();
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryTime.prototype, "name", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryTime.prototype, "initialValue", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryTime.prototype, "size", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryTime.prototype, "variant", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryTime.prototype, "label", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryTime.prototype, "placeholder", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryTime.prototype, "readonly", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryTime.prototype, "locked", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryTime.prototype, "mandatory", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryTime.prototype, "submitOnEnter", void 0);
    EntryTime = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_class_component___default.a
    ], EntryTime);
    return EntryTime;
}(__WEBPACK_IMPORTED_MODULE_2__form_form_component__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (EntryTime);


/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_class_component__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_class_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_class_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__form_form_component__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_dom__ = __webpack_require__(4);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};




var EntryUpload = /** @class */ (function (_super) {
    __extends(EntryUpload, _super);
    function EntryUpload() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Data
        _this.value = (_this.initialValue || "").toString();
        _this.valid = false;
        _this.hasFocus = 0;
        _this.showErrors = false;
        _this.showFilePicker = false;
        _this.isFileWord = false;
        _this.isFilePowerpoint = false;
        _this.isFileExcel = false;
        return _this;
    }
    EntryUpload.prototype.created = function () {
        _super.prototype.created.call(this);
        this.validate(true);
    };
    Object.defineProperty(EntryUpload.prototype, "isReadonly", {
        // Generated properties
        get: function () {
            return this.readonly || this.locked || this.$form.readonly;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryUpload.prototype, "entryClassName", {
        get: function () {
            var d = {
                "entry-upload": true,
                "no-label": !this.label,
                "highlight": this.hasFocus,
                "mandatory": this.mandatory,
                "readonly": this.isReadonly,
                "locked": this.locked,
                "error": this.showErrors && !this.valid
            };
            if (this.variant) {
                d['entry-upload--' + this.variant] = true;
            }
            return d;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryUpload.prototype, "fileTypeClassName", {
        get: function () {
            return {
                "file-type": true,
                "word": this.isFileWord,
                "powerpoint": this.isFilePowerpoint,
                "excel": this.isFileExcel
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryUpload.prototype, "entryId", {
        get: function () {
            return this.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryUpload.prototype, "hasValue", {
        get: function () {
            return !!this.value;
        },
        enumerable: true,
        configurable: true
    });
    // Events
    EntryUpload.prototype.onFocus = function (input) {
        if (input > 0) {
            this.hasFocus = input;
            this.showErrors = false;
        }
        else {
            if (!this.showFilePicker) {
                this.hasFocus = 0;
                this.showErrors = true;
            }
        }
    };
    EntryUpload.prototype.onShowFilePicker = function () {
        var _this = this;
        if (!this.showFilePicker) {
            if (this.hasFocus === 0) {
                this.onFocus(1);
            }
            this.showFilePicker = true;
        }
        else {
            this.showFilePicker = false;
        }
        Object(__WEBPACK_IMPORTED_MODULE_3__lib_dom__["b" /* E */])(document).once('click', function (evt) {
            if (evt.target instanceof HTMLElement && !Object(__WEBPACK_IMPORTED_MODULE_3__lib_dom__["a" /* D */])(evt.target).inside(_this.$el)) {
                _this.showFilePicker = false;
                return true;
            }
            return false;
        });
    };
    // Validation
    EntryUpload.prototype.validate = function (forceEmit) {
        if (forceEmit === void 0) { forceEmit = false; }
        var oldValid = this.valid;
        this.valid = !this.mandatory || !!this.value.trim();
        if (!this.isReadonly && (forceEmit || oldValid !== this.valid)) {
            this.$form.$emit("valid-change", { target: this, name: this.name, value: this.valid });
        }
    };
    // Public API
    EntryUpload.prototype.setValue = function (value) {
        if (value === null || value === undefined) {
            this.value = "";
        }
        else {
            this.value = value.toString();
        }
        this.validate();
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryUpload.prototype, "name", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryUpload.prototype, "initialValue", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryUpload.prototype, "size", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryUpload.prototype, "variant", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryUpload.prototype, "label", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])()
    ], EntryUpload.prototype, "placeholder", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryUpload.prototype, "readonly", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryUpload.prototype, "locked", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryUpload.prototype, "mandatory", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Prop"])({ default: false })
    ], EntryUpload.prototype, "submitOnEnter", void 0);
    EntryUpload = __decorate([
        __WEBPACK_IMPORTED_MODULE_0_vue_class_component___default.a
    ], EntryUpload);
    return EntryUpload;
}(__WEBPACK_IMPORTED_MODULE_2__form_form_component__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (EntryUpload);


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};


var FilePicker = /** @class */ (function (_super) {
    __extends(FilePicker, _super);
    function FilePicker() {
        // Data
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.actionBrowseHover = false;
        return _this;
    }
    FilePicker = __decorate([
        __WEBPACK_IMPORTED_MODULE_1_vue_property_decorator__["Component"]
    ], FilePicker);
    return FilePicker;
}(__WEBPACK_IMPORTED_MODULE_0_vue___default.a));
/* harmony default export */ __webpack_exports__["a"] = (FilePicker);


/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_property_decorator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_model__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_model__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__html_editor__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__form_form_component__ = __webpack_require__(2);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};





var EntryHtml = /** @class */ (function (_super) {
    __extends(EntryHtml, _super);
    function EntryHtml() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // Data
        _this.value = _this.initialValue;
        _this.valid = false;
        _this.hasFocus = false;
        _this.showErrors = false;
        return _this;
    }
    EntryHtml.prototype.onInitialValueChanged = function (newValue) {
        this.setValue(newValue);
        this.validate();
    };
    EntryHtml.prototype.created = function () {
        _super.prototype.created.call(this);
        this.validate(true);
    };
    EntryHtml.prototype.mounted = function () {
        var textarea = this.$refs.textarea;
        var editor = this.$refs.editor;
        if (editor instanceof HTMLElement && textarea instanceof HTMLTextAreaElement && !this.editorView) {
            this.editorView = Object(__WEBPACK_IMPORTED_MODULE_3__html_editor__["a" /* createEditor */])(editor, textarea.value, this.handleTransaction, this.handleFocus, this.handleBlur);
            this.domSerializer = __WEBPACK_IMPORTED_MODULE_2_prosemirror_model__["DOMSerializer"].fromSchema(this.editorView.state.schema);
        }
    };
    EntryHtml.prototype.handleTransaction = function (transaction) {
        // Manage editor transaction.
        var newState = this.editorView.state.apply(transaction);
        this.editorView.updateState(newState);
        // Get HTML from editor.
        this.value = this.getHTML();
        if (this.emitOnInput) {
            this.$emit("change", this.value);
        }
        this.validate();
    };
    EntryHtml.prototype.getHTML = function () {
        var tmp = document.createElement('div');
        tmp.appendChild(this.domSerializer.serializeFragment(this.editorView.state.doc.content));
        var html = tmp.innerHTML;
        if (html.trim() == '<p></p>') {
            return null;
        }
        return html;
    };
    Object.defineProperty(EntryHtml.prototype, "isReadonly", {
        // Generated properties
        get: function () {
            return this.readonly || this.locked || (this.$form && this.$form.readonly);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryHtml.prototype, "entryClassName", {
        get: function () {
            var d = {
                "entry-html": true,
                "no-label": !this.label,
                "highlight": this.hasFocus,
                "mandatory": this.mandatory,
                "readonly": this.isReadonly,
                "locked": this.locked,
                "error": this.showErrors && !this.valid && !this.hasFocus,
                "error-indicator": !this.valid
            };
            if (this.variant) {
                d['entry-html--' + this.variant] = true;
            }
            return d;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryHtml.prototype, "entryId", {
        get: function () {
            return this.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EntryHtml.prototype, "hasValue", {
        get: function () {
            return this.value != null;
        },
        enumerable: true,
        configurable: true
    });
    // Events
    EntryHtml.prototype.handleFocus = function (view, event) {
        this.onFocus(true);
        return false;
    };
    EntryHtml.prototype.handleBlur = function (view, event) {
        this.onFocus(false);
        return false;
    };
    EntryHtml.prototype.onFocus = function (isFocus) {
        if (isFocus) {
            this.focusValue = this.value;
            this.showErrors = false;
        }
        else {
            this.validate();
            this.showErrors = true;
            if (this.value !== this.focusValue) {
                this.$emit("change", this.value);
            }
        }
        this.hasFocus = isFocus;
    };
    // Validation
    EntryHtml.prototype.validate = function (forceEmit) {
        if (forceEmit === void 0) { forceEmit = false; }
        var oldValid = this.valid;
        this.valid = !this.mandatory || this.value != null;
        if (!this.isReadonly && (forceEmit || oldValid !== this.valid)) {
            this.$emit("valid-change", this.valid);
        }
    };
    // Public API
    EntryHtml.prototype.setValue = function (value) {
        if (value != this.value) {
            var content = document.createElement("div");
            content.innerHTML = value || '';
            var doc = __WEBPACK_IMPORTED_MODULE_2_prosemirror_model__["DOMParser"].fromSchema(this.editorView.state.schema).parse(content);
            var newState = __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["EditorState"].create({ schema: this.editorView.state.schema, doc: doc, plugins: this.editorView.state.plugins });
            this.editorView.updateState(newState);
            this.value = value;
            this.validate();
        }
    };
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryHtml.prototype, "name", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryHtml.prototype, "type", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryHtml.prototype, "size", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryHtml.prototype, "variant", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryHtml.prototype, "label", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryHtml.prototype, "placeholder", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])()
    ], EntryHtml.prototype, "initialValue", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], EntryHtml.prototype, "readonly", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], EntryHtml.prototype, "locked", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], EntryHtml.prototype, "mandatory", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Prop"])({ default: false })
    ], EntryHtml.prototype, "emitOnInput", void 0);
    __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Watch"])('initialValue')
    ], EntryHtml.prototype, "onInitialValueChanged", null);
    EntryHtml = __decorate([
        Object(__WEBPACK_IMPORTED_MODULE_0_vue_property_decorator__["Component"])({ model: { prop: 'initialValue', event: 'change' } })
    ], EntryHtml);
    return EntryHtml;
}(__WEBPACK_IMPORTED_MODULE_4__form_form_component__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (EntryHtml);


/***/ }),
/* 45 */
/***/ (function(module, exports) {

module.exports = require("prosemirror-model");

/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports = require("prosemirror-history");

/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports = require("prosemirror-menu");

/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports = require("prosemirror-inputrules");

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(12);


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wok-form" }, [
    _c(
      "form",
      {
        ref: "form",
        attrs: {
          name: _vm.name,
          method: _vm.method,
          action: _vm.action,
          enctype: _vm.enctype
        },
        on: {
          submit: function($event) {
            $event.stopPropagation()
            $event.preventDefault()
            _vm.onSubmit($event)
          },
          click: _vm.onButtonClick
        }
      },
      [
        _vm._t("header-actions"),
        _vm._v(" "),
        _vm._t("default"),
        _vm._v(" "),
        _vm._t("primary-actions")
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-49f8f026", esExports)
  }
}

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_row_vue__ = __webpack_require__(15);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fa18930_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_row_vue__ = __webpack_require__(52);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_row_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4fa18930_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_row_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/form/row.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4fa18930", Component.options)
  } else {
    hotAPI.reload("data-v-4fa18930", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["row", _vm.variant ? "row--" + _vm.variant : null] },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4fa18930", esExports)
  }
}

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_actions_row_vue__ = __webpack_require__(16);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0b476d0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_actions_row_vue__ = __webpack_require__(54);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_actions_row_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d0b476d0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_actions_row_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/form/actions-row.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d0b476d0", Component.options)
  } else {
    hotAPI.reload("data-v-d0b476d0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["row row--actions", _vm.variant ? "row--" + _vm.variant : null] },
    [
      _c("div", { class: _vm.getClassName("left") }, [
        _c("div", { staticClass: "content" }, [_vm._t("left")], 2)
      ]),
      _vm._v(" "),
      _c("div", { class: _vm.getClassName("center") }, [
        _c("div", { staticClass: "content" }, [_vm._t("center")], 2)
      ]),
      _vm._v(" "),
      _c("div", { class: _vm.getClassName("right") }, [
        _c("div", { staticClass: "content" }, [_vm._t("right")], 2)
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d0b476d0", esExports)
  }
}

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pill_vue__ = __webpack_require__(17);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1114221b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pill_vue__ = __webpack_require__(56);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pill_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1114221b_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pill_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/form/pill.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1114221b", Component.options)
  } else {
    hotAPI.reload("data-v-1114221b", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "wok-pill",
        _vm.variant ? "wok-pill--" + _vm.variant : null,
        _vm.spacing ? "spacing--" + _vm.spacing : null,
        _vm.rounded ? "rounded" : null
      ]
    },
    [_c("div", { staticClass: "content" }, [_vm._t("default")], 2)]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1114221b", esExports)
  }
}

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pill_switch_vue__ = __webpack_require__(18);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a80c2d6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pill_switch_vue__ = __webpack_require__(58);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_pill_switch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a80c2d6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_pill_switch_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/form/pill-switch.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2a80c2d6", Component.options)
  } else {
    hotAPI.reload("data-v-2a80c2d6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        "wok-pill",
        _vm.variant ? "wok-pill--" + _vm.variant : null,
        _vm.spacing ? "spacing--" + _vm.spacing : null,
        _vm.rounded ? "rounded" : null
      ]
    },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c("form-row", { attrs: { variant: "switch-title" } }, [
            _c("div", { staticClass: "c-form-title-switch" }, [
              _c("div", { staticClass: "content" }, [
                _c(
                  "div",
                  {
                    class: [
                      "form-title",
                      _vm.variant ? "form-title--" + _vm.variant : null
                    ]
                  },
                  [_c("h2", [_vm._v(_vm._s(_vm.title))])]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "switch" }, [
                  _c(
                    "div",
                    { staticClass: "content" },
                    _vm._l(_vm.options, function(o, i) {
                      return _c("div", { key: i, staticClass: "switch-item" }, [
                        _c("input", {
                          attrs: {
                            type: "radio",
                            name: _vm.name,
                            id: _vm.getId(o)
                          },
                          domProps: {
                            value: o.value,
                            checked: _vm.value === o.value
                          },
                          on: { change: _vm.onChange }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            class: { active: _vm.value === o.value },
                            attrs: { for: _vm.getId(o) }
                          },
                          [_vm._v(_vm._s(o.label))]
                        )
                      ])
                    })
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "transition",
            { attrs: { name: "slot-fade", mode: "out-in" } },
            _vm._l(_vm.optionsCount, function(i) {
              return _vm.slotIsVisible(i)
                ? _c(
                    "div",
                    { key: i, staticClass: "slot-wrapper" },
                    [_vm._t(_vm.slotName(i))],
                    2
                  )
                : _vm._e()
            })
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2a80c2d6", esExports)
  }
}

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_title_vue__ = __webpack_require__(19);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b3d3e9e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_title_vue__ = __webpack_require__(60);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_title_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b3d3e9e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_title_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/texts/form-title.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6b3d3e9e", Component.options)
  } else {
    hotAPI.reload("data-v-6b3d3e9e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-form-title" }, [
    _c(
      "div",
      {
        class: ["form-title", _vm.variant ? "form-title--" + _vm.variant : null]
      },
      [_c("h2", [_vm._t("default")], 2)]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b3d3e9e", esExports)
  }
}

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_text_vue__ = __webpack_require__(20);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a9ea564_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_text_vue__ = __webpack_require__(62);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_form_text_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a9ea564_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_form_text_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/texts/form-text.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4a9ea564", Component.options)
  } else {
    hotAPI.reload("data-v-4a9ea564", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-form-text" }, [
    _c(
      "div",
      {
        class: ["form-text", _vm.variant ? "form-text--" + _vm.variant : null]
      },
      [_c("h3", [_vm._t("default")], 2)]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a9ea564", esExports)
  }
}

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_spacer_vue__ = __webpack_require__(21);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6332915f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_spacer_vue__ = __webpack_require__(64);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_spacer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6332915f_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_spacer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/entries/entry-spacer.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6332915f", Component.options)
  } else {
    hotAPI.reload("data-v-6332915f", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.cellClassName }, [
    _c("div", { class: _vm.entryClassName }, [
      _c("span", { staticClass: "spacer" })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6332915f", esExports)
  }
}

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.cellClassName }, [
    _vm.isReadonly
      ? _c("div", { class: _vm.entryClassName }, [
          _c("label", { staticClass: "show", attrs: { for: _vm.entryId } }, [
            _vm._v(_vm._s(_vm.label))
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "readonly-value" }, [
            _vm._v(_vm._s(_vm.value))
          ])
        ])
      : _c("div", { class: _vm.entryClassName }, [
          _c(
            "label",
            { class: { show: _vm.hasValue }, attrs: { for: _vm.entryId } },
            [_vm._v(_vm._s(_vm.label))]
          ),
          _vm._v(" "),
          _c("input", {
            ref: "input",
            attrs: {
              type: "text",
              id: _vm.entryId,
              name: _vm.name,
              placeholder: _vm.hasValue ? null : _vm.placeholder || _vm.label
            },
            domProps: { value: _vm.value },
            on: {
              input: _vm.onInput,
              keyup: function($event) {
                if (!("button" in $event) && $event.keyCode !== 13) {
                  return null
                }
                _vm.onKeyEnter($event)
              },
              focus: function($event) {
                _vm.onFocus(true)
              },
              blur: function($event) {
                _vm.onFocus(false)
              }
            }
          })
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9b54aec0", esExports)
  }
}

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_textarea_vue__ = __webpack_require__(23);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea37b2a6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_textarea_vue__ = __webpack_require__(67);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_textarea_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ea37b2a6_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_textarea_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/entries/entry-textarea.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ea37b2a6", Component.options)
  } else {
    hotAPI.reload("data-v-ea37b2a6", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isReadonly
    ? _c("div", { class: _vm.cellClassName }, [
        _c("div", { class: _vm.entryClassName }, [
          _c(
            "label",
            { class: { show: _vm.hasValue }, attrs: { for: _vm.entryId } },
            [_vm._v(_vm._s(_vm.label))]
          ),
          _vm._v(" "),
          _c("textarea", {
            ref: "textarea",
            attrs: {
              id: _vm.entryId,
              name: _vm.name,
              placeholder: _vm.hasValue ? null : _vm.placeholder || _vm.label
            },
            domProps: { value: _vm.value },
            on: {
              input: _vm.onInput,
              focus: function($event) {
                _vm.onFocus(true)
              },
              blur: function($event) {
                _vm.onFocus(false)
              }
            }
          })
        ])
      ])
    : _c("div", { class: _vm.cellClassName }, [
        _c("div", { class: _vm.entryClassName }, [
          _c("label", { staticClass: "show", attrs: { for: _vm.entryId } }, [
            _vm._v(_vm._s(_vm.label))
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "readonly-value" }, [
            _vm._v(_vm._s(_vm.value))
          ])
        ])
      ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ea37b2a6", esExports)
  }
}

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_password_vue__ = __webpack_require__(24);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23d7918e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_password_vue__ = __webpack_require__(69);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_password_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23d7918e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_password_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/entries/entry-password.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-23d7918e", Component.options)
  } else {
    hotAPI.reload("data-v-23d7918e", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.cellClassName }, [
    _vm.isReadonly
      ? _c("div", { class: _vm.entryClassName }, [
          _c("label", { staticClass: "show", attrs: { for: _vm.entryId } }, [
            _vm._v(_vm._s(_vm.label))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "wrapper" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "input" }, [
              _c("span", { staticClass: "readonly-value" }, [
                _vm._v(_vm._s(_vm.value))
              ])
            ])
          ])
        ])
      : _c("div", { class: _vm.entryClassName }, [
          _c(
            "label",
            { class: { show: _vm.hasValue }, attrs: { for: _vm.entryId } },
            [_vm._v(_vm._s(_vm.label))]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "wrapper" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "input" }, [
              _c("input", {
                ref: "input",
                attrs: {
                  type: "password",
                  id: _vm.entryId,
                  name: _vm.name,
                  placeholder: _vm.hasValue
                    ? null
                    : _vm.placeholder || _vm.label
                },
                domProps: { value: _vm.value },
                on: {
                  input: _vm.onInput,
                  keyup: function($event) {
                    if (!("button" in $event) && $event.keyCode !== 13) {
                      return null
                    }
                    _vm.onKeyEnter($event)
                  },
                  focus: function($event) {
                    _vm.onFocus(true)
                  },
                  blur: function($event) {
                    _vm.onFocus(false)
                  }
                }
              })
            ])
          ])
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-wrapper" }, [
      _c("div", { staticClass: "icon-password" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-wrapper" }, [
      _c("div", { staticClass: "icon-password" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-23d7918e", esExports)
  }
}

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_mail_vue__ = __webpack_require__(25);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24e9d7ac_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_mail_vue__ = __webpack_require__(71);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_mail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24e9d7ac_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_mail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/entries/entry-mail.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-24e9d7ac", Component.options)
  } else {
    hotAPI.reload("data-v-24e9d7ac", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.cellClassName }, [
    _vm.isReadonly
      ? _c("div", { class: _vm.entryClassName }, [
          _c("label", { staticClass: "show", attrs: { for: _vm.entryId } }, [
            _vm._v(_vm._s(_vm.label))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "wrapper" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "input" }, [
              _c("span", { staticClass: "readonly-value" }, [
                _vm._v(_vm._s(_vm.value))
              ])
            ])
          ])
        ])
      : _c("div", { class: _vm.entryClassName }, [
          _c(
            "label",
            { class: { show: _vm.hasValue }, attrs: { for: _vm.entryId } },
            [_vm._v(_vm._s(_vm.label))]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "wrapper" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "input" }, [
              _c("input", {
                ref: "input",
                attrs: {
                  type: "text",
                  id: _vm.entryId,
                  name: _vm.name,
                  placeholder: _vm.hasValue
                    ? null
                    : _vm.placeholder || _vm.label
                },
                domProps: { value: _vm.value },
                on: {
                  input: _vm.onInput,
                  keyup: function($event) {
                    if (!("button" in $event) && $event.keyCode !== 13) {
                      return null
                    }
                    _vm.onKeyEnter($event)
                  },
                  focus: function($event) {
                    _vm.onFocus(true)
                  },
                  blur: function($event) {
                    _vm.onFocus(false)
                  }
                }
              })
            ])
          ])
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-wrapper" }, [
      _c("div", { staticClass: "icon-mail" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-wrapper" }, [
      _c("div", { staticClass: "icon-mail" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24e9d7ac", esExports)
  }
}

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_phone_vue__ = __webpack_require__(26);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8fb35ea_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_phone_vue__ = __webpack_require__(73);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_phone_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c8fb35ea_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_phone_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/entries/entry-phone.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c8fb35ea", Component.options)
  } else {
    hotAPI.reload("data-v-c8fb35ea", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.cellClassName }, [
    _vm.isReadonly
      ? _c("div", { class: _vm.entryClassName }, [
          _c("label", { staticClass: "show", attrs: { for: _vm.entryId } }, [
            _vm._v(_vm._s(_vm.label))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "wrapper" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "input" }, [
              _c("span", { staticClass: "readonly-value" }, [
                _vm._v(_vm._s(_vm.value))
              ])
            ])
          ])
        ])
      : _c("div", { class: _vm.entryClassName }, [
          _c(
            "label",
            { class: { show: _vm.hasValue }, attrs: { for: _vm.entryId } },
            [_vm._v(_vm._s(_vm.label))]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "wrapper" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "input" }, [
              _c("input", {
                ref: "input",
                attrs: {
                  type: "text",
                  id: _vm.entryId,
                  name: _vm.name,
                  placeholder: _vm.hasValue
                    ? null
                    : _vm.placeholder || _vm.label
                },
                domProps: { value: _vm.value },
                on: {
                  input: _vm.onInput,
                  keyup: function($event) {
                    if (!("button" in $event) && $event.keyCode !== 13) {
                      return null
                    }
                    _vm.onKeyEnter($event)
                  },
                  focus: function($event) {
                    _vm.onFocus(true)
                  },
                  blur: function($event) {
                    _vm.onFocus(false)
                  }
                }
              })
            ])
          ])
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-wrapper" }, [
      _c("div", { staticClass: "icon-phone" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-wrapper" }, [
      _c("div", { staticClass: "icon-phone" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c8fb35ea", esExports)
  }
}

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_pnr_vue__ = __webpack_require__(27);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59d64411_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_pnr_vue__ = __webpack_require__(75);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_pnr_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59d64411_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_pnr_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/entries/entry-pnr.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-59d64411", Component.options)
  } else {
    hotAPI.reload("data-v-59d64411", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-entry-pnr" }, [
    _vm.isReadonly
      ? _c("div", { class: _vm.entryClassName }, [
          _c("label", { staticClass: "show" }, [_vm._v(_vm._s(_vm.label))]),
          _vm._v(" "),
          _c("span", { staticClass: "readonly-value" }, [
            _vm._v(_vm._s(_vm.value))
          ])
        ])
      : _c("div", { class: _vm.entryClassName }, [
          _c("label", { staticClass: "show" }, [_vm._v(_vm._s(_vm.label))]),
          _vm._v(" "),
          _c("div", { staticClass: "input-wrapper" }, [
            _c("input", {
              ref: "input",
              attrs: {
                type: "text",
                id: _vm.entryId,
                name: _vm.name,
                placeholder: _vm.hasValue1 ? null : _vm.placeholder,
                maxlength: "4"
              },
              domProps: { value: _vm.value1 },
              on: {
                paste: _vm.onPaste,
                input: _vm.onInput1,
                keyup: function($event) {
                  if (!("button" in $event) && $event.keyCode !== 13) {
                    return null
                  }
                  _vm.onKeyEnter($event)
                },
                focus: function($event) {
                  _vm.onFocus(true)
                },
                blur: function($event) {
                  _vm.onFocus(false)
                }
              }
            }),
            _vm._v(" "),
            _c("span", [_vm._v("–")]),
            _vm._v(" "),
            _c("input", {
              ref: "input",
              attrs: {
                type: "text",
                id: _vm.entryId,
                name: _vm.name,
                placeholder: _vm.hasValue2 ? null : _vm.placeholder,
                maxlength: "4"
              },
              domProps: { value: _vm.value2 },
              on: {
                input: _vm.onInput2,
                keyup: function($event) {
                  if (!("button" in $event) && $event.keyCode !== 13) {
                    return null
                  }
                  _vm.onKeyEnter($event)
                },
                focus: function($event) {
                  _vm.onFocus(true)
                },
                blur: function($event) {
                  _vm.onFocus(false)
                }
              }
            })
          ])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59d64411", esExports)
  }
}

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_euro_vue__ = __webpack_require__(28);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ff79b40_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_euro_vue__ = __webpack_require__(77);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_euro_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ff79b40_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_euro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/entries/entry-euro.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3ff79b40", Component.options)
  } else {
    hotAPI.reload("data-v-3ff79b40", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.cellClassName }, [
    _vm.isReadonly
      ? _c("div", { class: _vm.entryClassName }, [
          _c("label", { staticClass: "show", attrs: { for: _vm.entryId } }, [
            _vm._v(_vm._s(_vm.label))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "wrapper" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "input" }, [
              _c("span", { staticClass: "readonly-value" }, [
                _vm._v(_vm._s(_vm.value))
              ])
            ])
          ])
        ])
      : _c("div", { class: _vm.entryClassName }, [
          _c(
            "label",
            { class: { show: _vm.hasValue }, attrs: { for: _vm.entryId } },
            [_vm._v(_vm._s(_vm.label))]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "wrapper" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "input" }, [
              _c("input", {
                ref: "input",
                attrs: {
                  type: "text",
                  id: _vm.entryId,
                  name: _vm.name,
                  placeholder: _vm.hasValue
                    ? null
                    : _vm.placeholder || _vm.label
                },
                domProps: { value: _vm.value },
                on: {
                  input: _vm.onInput,
                  keyup: function($event) {
                    if (!("button" in $event) && $event.keyCode !== 13) {
                      return null
                    }
                    _vm.onKeyEnter($event)
                  },
                  focus: function($event) {
                    _vm.onFocus(true)
                  },
                  blur: function($event) {
                    _vm.onFocus(false)
                  }
                }
              })
            ])
          ])
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-wrapper" }, [
      _c("div", { staticClass: "icon-euro" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-wrapper" }, [
      _c("div", { staticClass: "icon-euro" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ff79b40", esExports)
  }
}

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_color_vue__ = __webpack_require__(29);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4eea5480_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_color_vue__ = __webpack_require__(79);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_color_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4eea5480_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_color_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/entries/entry-color.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4eea5480", Component.options)
  } else {
    hotAPI.reload("data-v-4eea5480", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-entry-color" },
    [
      _vm.isReadonly
        ? _c("div", { class: _vm.entryClassName }, [
            _c("label", { staticClass: "show", attrs: { for: _vm.entryId } }, [
              _vm._v(_vm._s(_vm.label))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "wrapper" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "input" }, [
                _c("span", { staticClass: "readonly-value" }, [
                  _vm._v(_vm._s(_vm.value))
                ])
              ]),
              _vm._v(" "),
              _vm._m(1)
            ])
          ])
        : _c("div", { class: _vm.entryClassName }, [
            _c(
              "label",
              { class: { show: _vm.hasValue }, attrs: { for: _vm.entryId } },
              [_vm._v(_vm._s(_vm.label))]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "wrapper" }, [
              _c("div", { staticClass: "icon-wrapper" }, [
                _c("div", { staticClass: "icon-color" }, [
                  !_vm.lite
                    ? _c("button", {
                        class: { open: _vm.showColorPicker },
                        attrs: { type: "button" },
                        on: { click: _vm.onShowColorPicker }
                      })
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "input" }, [
                _c("input", {
                  ref: "input",
                  attrs: {
                    type: "text",
                    id: _vm.entryId,
                    name: _vm.name,
                    placeholder: _vm.hasValue
                      ? null
                      : _vm.placeholder || _vm.label
                  },
                  domProps: { value: _vm.value },
                  on: {
                    input: _vm.onInput,
                    keyup: function($event) {
                      if (!("button" in $event) && $event.keyCode !== 13) {
                        return null
                      }
                      _vm.onKeyEnter($event)
                    },
                    focus: function($event) {
                      _vm.onFocus(true)
                    },
                    blur: function($event) {
                      _vm.onFocus(false)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "action" }, [
                _c("button", {
                  key: _vm.value,
                  staticClass: "action-color",
                  style: _vm.selectedColor,
                  attrs: { type: "button" },
                  on: { click: _vm.onShowColorPicker }
                })
              ])
            ])
          ]),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [_vm.showColorPicker ? _c("color-picker") : _vm._e()],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-wrapper" }, [
      _c("div", { staticClass: "icon-color" }, [
        _c("button", { attrs: { type: "button" } })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "action" }, [
      _c("button", { staticClass: "action-color", attrs: { type: "button" } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4eea5480", esExports)
  }
}

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_color_picker_vue__ = __webpack_require__(30);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62f8d8bb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_color_picker_vue__ = __webpack_require__(81);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_color_picker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_62f8d8bb_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_color_picker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/pickers/color-picker.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-62f8d8bb", Component.options)
  } else {
    hotAPI.reload("data-v-62f8d8bb", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "color-popup" }, [
      _c("div", { staticClass: "content" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62f8d8bb", esExports)
  }
}

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_select_vue__ = __webpack_require__(31);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d24a3a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_select_vue__ = __webpack_require__(83);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_select_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d24a3a2_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_select_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/entries/entry-select.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3d24a3a2", Component.options)
  } else {
    hotAPI.reload("data-v-3d24a3a2", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.cellClassName }, [
    _vm.isReadonly
      ? _c("div", { class: _vm.entryClassName }, [
          _c("label", { staticClass: "show", attrs: { for: _vm.entryId } }, [
            _vm._v(_vm._s(_vm.label))
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "readonly-value" }, [
            _vm._v(_vm._s(_vm.displayValue))
          ])
        ])
      : _c("div", { class: _vm.entryClassName }, [
          _c("label", { staticClass: "show", attrs: { for: _vm.entryId } }, [
            _vm._v(_vm._s(_vm.label))
          ]),
          _vm._v(" "),
          _c(
            "select",
            {
              attrs: { name: _vm.name, id: _vm.entryId },
              domProps: { value: _vm.value },
              on: {
                focus: function($event) {
                  _vm.hasFocus = true
                },
                blur: function($event) {
                  _vm.hasFocus = false
                },
                change: _vm.onChange
              }
            },
            _vm._l(_vm.optionItems, function(o) {
              return _c(
                "option",
                { key: o.value, domProps: { value: o.value } },
                [_vm._v(_vm._s(o.label))]
              )
            })
          )
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d24a3a2", esExports)
  }
}

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_checkbox_group_vue__ = __webpack_require__(32);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3cadcb0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_checkbox_group_vue__ = __webpack_require__(85);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_checkbox_group_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3cadcb0_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_checkbox_group_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/entries/entry-checkbox-group.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f3cadcb0", Component.options)
  } else {
    hotAPI.reload("data-v-f3cadcb0", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.cellClassName }, [
    _c(
      "div",
      { class: _vm.entryClassName },
      [
        _c("label", [_vm._v(_vm._s(_vm.label))]),
        _vm._v(" "),
        _vm._l(_vm.optionItems, function(o, i) {
          return _c("div", { key: i, staticClass: "entry-check-item" }, [
            _c("input", {
              attrs: { type: "checkbox", name: _vm.name, id: _vm.getId(o) },
              domProps: {
                value: o.value,
                checked:
                  !!_vm.value &&
                  _vm.value.some(function(x) {
                    return x == o.value
                  })
              },
              on: { change: _vm.onChange }
            }),
            _vm._v(" "),
            _c("label", { attrs: { for: _vm.getId(o) } }, [
              _vm._v(_vm._s(o.label))
            ])
          ])
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f3cadcb0", esExports)
  }
}

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_radio_group_vue__ = __webpack_require__(33);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc8c62ec_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_radio_group_vue__ = __webpack_require__(87);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_radio_group_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fc8c62ec_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_radio_group_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/entries/entry-radio-group.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-fc8c62ec", Component.options)
  } else {
    hotAPI.reload("data-v-fc8c62ec", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.cellClassName }, [
    _c(
      "div",
      { class: _vm.entryClassName },
      [
        _c("label", [_vm._v(_vm._s(_vm.label))]),
        _vm._v(" "),
        _vm._l(_vm.optionItems, function(o, i) {
          return _c("div", { key: i, staticClass: "entry-radio-item" }, [
            _c("input", {
              attrs: { type: "radio", name: _vm.name, id: _vm.getId(o) },
              domProps: { value: o.value, checked: o.value === _vm.value },
              on: { change: _vm.onChange }
            }),
            _vm._v(" "),
            _c("label", { attrs: { for: _vm.getId(o) } }, [
              _vm._v(_vm._s(o.label))
            ])
          ])
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fc8c62ec", esExports)
  }
}

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_date_vue__ = __webpack_require__(34);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59032aa1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_date_vue__ = __webpack_require__(89);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_date_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59032aa1_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_date_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/entries/entry-date.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-59032aa1", Component.options)
  } else {
    hotAPI.reload("data-v-59032aa1", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.cellClassName },
    [
      _vm.isReadonly
        ? _c("div", { class: _vm.entryClassName }, [
            _c("label", { staticClass: "show" }, [_vm._v(_vm._s(_vm.label))]),
            _vm._v(" "),
            _c("div", { staticClass: "wrapper" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "input" }, [
                _c("span", { staticClass: "readonly-value" }, [
                  _vm._v(_vm._s(_vm.displayValue))
                ])
              ])
            ])
          ])
        : _c("div", { class: _vm.entryClassName }, [
            _c("label", { class: { show: _vm.hasDisplayValue } }, [
              _vm._v(_vm._s(_vm.label))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "wrapper" }, [
              _c("div", { staticClass: "icon-wrapper" }, [
                _c("div", { staticClass: "icon-calendar" }, [
                  _c("button", {
                    class: { open: _vm.showCalendar },
                    attrs: { type: "button" },
                    on: { click: _vm.onShowCalendar }
                  })
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input" },
                [
                  _c("input", {
                    attrs: {
                      type: "text",
                      placeholder: _vm.hasValue
                        ? null
                        : _vm.placeholder || _vm.label
                    },
                    domProps: { value: _vm.displayValue },
                    on: {
                      focus: function($event) {
                        _vm.onFocus(1)
                      },
                      blur: function($event) {
                        _vm.onFocus(0)
                      },
                      input: _vm.onInput
                    }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    attrs: { type: "hidden", name: _vm.name },
                    domProps: { value: _vm.value }
                  }),
                  _vm._v(" "),
                  !_vm.showCalendar && _vm.valid
                    ? [
                        _c("button", {
                          staticClass: "prev",
                          attrs: { type: "button" },
                          on: { click: _vm.prevDay }
                        }),
                        _vm._v(" "),
                        _c("button", {
                          staticClass: "next",
                          attrs: { type: "button" },
                          on: { click: _vm.nextDay }
                        })
                      ]
                    : _vm._e()
                ],
                2
              )
            ])
          ]),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.showCalendar
            ? _c("date-picker", {
                attrs: { initialValue: _vm.valid ? _vm.value : null },
                on: { change: _vm.onPickerChange }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-wrapper" }, [
      _c("div", { staticClass: "icon-calendar" }, [
        _c("button", { attrs: { type: "button" } })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59032aa1", esExports)
  }
}

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_date_picker_vue__ = __webpack_require__(35);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51de5a5a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_date_picker_vue__ = __webpack_require__(91);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_date_picker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51de5a5a_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_date_picker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/pickers/date-picker.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-51de5a5a", Component.options)
  } else {
    hotAPI.reload("data-v-51de5a5a", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "calendar-popup" }, [
    _vm.showDays
      ? _c("div", { staticClass: "calendar-days" }, [
          _c("div", { staticClass: "header" }, [
            _c("div", {
              staticClass: "prev-btn",
              on: { click: _vm.prevMonth }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "switch", on: { click: _vm.setShowYears } },
              [_vm._v(_vm._s(_vm.headerMonth) + " " + _vm._s(_vm.headerYear))]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "next-btn", on: { click: _vm.nextMonth } })
          ]),
          _vm._v(" "),
          _c("table", [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "tbody",
              { on: { click: _vm.setCurrent } },
              _vm._l(_vm.calendarWeeks, function(w) {
                return _c(
                  "tr",
                  _vm._l(w, function(d) {
                    return _c(
                      "td",
                      {
                        class: {
                          "not-current-month": !d.isCurrentMonth,
                          "current-day": d.isCurrentDay,
                          today: d.isToday
                        },
                        attrs: { "data-date": d.isoDate }
                      },
                      [_vm._v(_vm._s(d.dayOfMonth))]
                    )
                  })
                )
              })
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.showYears
      ? _c("div", { staticClass: "calendar-years" }, [
          _c("div", { staticClass: "header" }, [
            _c("div", {
              staticClass: "prev-btn",
              on: { click: _vm.prevDecades }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "switch" }, [
              _vm._v(_vm._s(_vm.headerDecade))
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "next-btn",
              on: { click: _vm.nextDecades }
            })
          ]),
          _vm._v(" "),
          _c("table", [
            _c("tbody", { on: { click: _vm.setCurrentYear } }, [
              _c("tr", [
                _c(
                  "td",
                  _vm._l(_vm.calendarYears, function(y) {
                    return _c("span", { attrs: { "data-year": y } }, [
                      _vm._v(_vm._s(y))
                    ])
                  })
                )
              ])
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c(
        "tr",
        _vm._l(_vm.daysNames, function(d) {
          return _c("th", { staticClass: "dow" }, [_vm._v(_vm._s(d))])
        })
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51de5a5a", esExports)
  }
}

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_period_vue__ = __webpack_require__(37);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b0a0474_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_period_vue__ = __webpack_require__(93);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_period_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b0a0474_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_period_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/entries/entry-period.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5b0a0474", Component.options)
  } else {
    hotAPI.reload("data-v-5b0a0474", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.cellClassName },
    [
      _vm.isReadonly
        ? _c("div", { class: _vm.entryClassName }, [
            _c("label", { staticClass: "show" }, [_vm._v(_vm._s(_vm.label))]),
            _vm._v(" "),
            _c("div", { staticClass: "wrapper" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "input first" }, [
                _c("div", { staticClass: "input-wrapper" }, [
                  _c("div", { staticClass: "from-wrapper" }, [
                    _c("span", { staticClass: "from" }, [
                      _vm._v(_vm._s(_vm.labelFrom))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-wrapper" }, [
                    _c("span", { staticClass: "readonly-value" }, [
                      _vm._v(_vm._s(_vm.displayFrom))
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "input second" }, [
                _c("div", { staticClass: "input-wrapper" }, [
                  _c("div", { staticClass: "from-wrapper" }, [
                    _c("span", { staticClass: "from" }, [
                      _vm._v(_vm._s(_vm.labelTo))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "text-wrapper" }, [
                    _c("span", { staticClass: "readonly-value" }, [
                      _vm._v(_vm._s(_vm.displayTo))
                    ])
                  ])
                ])
              ])
            ])
          ])
        : _c("div", { class: _vm.entryClassName }, [
            _c("label", [_vm._v(_vm._s(_vm.label))]),
            _vm._v(" "),
            _c("div", { staticClass: "wrapper" }, [
              _c("div", { staticClass: "icon-wrapper" }, [
                _c("div", { staticClass: "icon-calendar" }, [
                  _c("button", {
                    class: { open: _vm.showCalendar },
                    attrs: { type: "button" },
                    on: { click: _vm.onShowCalendar }
                  })
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: [
                    "input first",
                    { active: _vm.hasFocus === 1 && _vm.showCalendar }
                  ]
                },
                [
                  _c("div", { staticClass: "input-wrapper" }, [
                    _c("div", { staticClass: "from-wrapper" }, [
                      _c("span", { staticClass: "from" }, [
                        _vm._v(_vm._s(_vm.labelFrom))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-wrapper" }, [
                      _c("input", {
                        attrs: { type: "text" },
                        domProps: { value: _vm.displayFrom },
                        on: {
                          focus: function($event) {
                            _vm.onFocus(1)
                          },
                          blur: function($event) {
                            _vm.onFocus(0)
                          },
                          input: _vm.onInput1
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        attrs: { type: "hidden", name: _vm.input1Name },
                        domProps: { value: _vm.from }
                      })
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: [
                    "input second",
                    {
                      input: true,
                      active: _vm.hasFocus === 2 && _vm.showCalendar
                    }
                  ]
                },
                [
                  _c("div", { staticClass: "input-wrapper" }, [
                    _c("div", { staticClass: "to-wrapper" }, [
                      _c("span", { staticClass: "to" }, [
                        _vm._v(_vm._s(_vm.labelTo))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-wrapper" }, [
                      _c("input", {
                        attrs: { type: "text" },
                        domProps: { value: _vm.displayTo },
                        on: {
                          focus: function($event) {
                            _vm.onFocus(2)
                          },
                          blur: function($event) {
                            _vm.onFocus(0)
                          },
                          input: _vm.onInput2
                        }
                      }),
                      _vm._v(" "),
                      _c("input", {
                        attrs: { type: "hidden", name: _vm.input2Name },
                        domProps: { value: _vm.to }
                      })
                    ])
                  ])
                ]
              )
            ])
          ]),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.showCalendar
            ? _c("period-picker", {
                attrs: {
                  initialFromValue: _vm.valid ? _vm.from : null,
                  initialToValue: _vm.valid ? _vm.to : null,
                  initialActivePeriodFrom: _vm.hasFocus === 1
                },
                on: {
                  "change-from": _vm.onPickerChangeFrom,
                  "change-to": _vm.onPickerChangeTo
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-wrapper" }, [
      _c("div", { staticClass: "icon-calendar" }, [
        _c("button", { attrs: { type: "button" } })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b0a0474", esExports)
  }
}

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_period_picker_vue__ = __webpack_require__(38);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c2f8127_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_period_picker_vue__ = __webpack_require__(95);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_period_picker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c2f8127_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_period_picker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/pickers/period-picker.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0c2f8127", Component.options)
  } else {
    hotAPI.reload("data-v-0c2f8127", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "calendar-popup" }, [
    _vm.showDays
      ? _c("div", { staticClass: "calendar-days" }, [
          _c("div", { staticClass: "header" }, [
            _c("div", {
              staticClass: "prev-btn",
              on: { click: _vm.prevMonth }
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "switch", on: { click: _vm.setShowYears } },
              [
                _vm._v(
                  _vm._s(_vm.headerMonth(0)) + " " + _vm._s(_vm.headerYear(0))
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "switch", on: { click: _vm.setShowYears } },
              [
                _vm._v(
                  _vm._s(_vm.headerMonth(1)) + " " + _vm._s(_vm.headerYear(1))
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "next-btn", on: { click: _vm.nextMonth } })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "table-wrapper" }, [
            _c("table", [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "tbody",
                { on: { click: _vm.setCurrent } },
                _vm._l(_vm.calendarWeeks(0), function(w) {
                  return _c(
                    "tr",
                    [
                      _vm._l(w, function(d) {
                        return [
                          d.isCurrentMonth
                            ? _c(
                                "td",
                                {
                                  class: {
                                    "period-from-day": d.isPeriodFrom,
                                    "period-to-day": d.isPeriodTo,
                                    "in-period": d.isInPeriod,
                                    today: d.isToday
                                  },
                                  attrs: { "data-date": d.isoDate }
                                },
                                [_vm._v(_vm._s(d.dayOfMonth))]
                              )
                            : _c("td", { staticClass: "not-current-month" })
                        ]
                      })
                    ],
                    2
                  )
                })
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "table-wrapper" }, [
            _c("table", [
              _vm._m(1),
              _vm._v(" "),
              _c(
                "tbody",
                { on: { click: _vm.setCurrent } },
                _vm._l(_vm.calendarWeeks(1), function(w) {
                  return _c(
                    "tr",
                    [
                      _vm._l(w, function(d) {
                        return [
                          d.isCurrentMonth
                            ? _c(
                                "td",
                                {
                                  class: {
                                    "period-from-day": d.isPeriodFrom,
                                    "period-to-day": d.isPeriodTo,
                                    "in-period": d.isInPeriod,
                                    today: d.isToday
                                  },
                                  attrs: { "data-date": d.isoDate }
                                },
                                [_vm._v(_vm._s(d.dayOfMonth))]
                              )
                            : _c("td", { staticClass: "not-current-month" })
                        ]
                      })
                    ],
                    2
                  )
                })
              )
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.showYears
      ? _c("div", { staticClass: "calendar-years" }, [
          _c("div", { staticClass: "header" }, [
            _c("div", {
              staticClass: "prev-btn",
              on: { click: _vm.prevDecades }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "switch" }, [
              _vm._v(_vm._s(_vm.headerDecade))
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "next-btn",
              on: { click: _vm.nextDecades }
            })
          ]),
          _vm._v(" "),
          _c("table", [
            _c("tbody", { on: { click: _vm.setCurrentYear } }, [
              _c("tr", [
                _c(
                  "td",
                  _vm._l(_vm.calendarYears, function(y) {
                    return _c("span", { attrs: { "data-year": y } }, [
                      _vm._v(_vm._s(y))
                    ])
                  })
                )
              ])
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c(
        "tr",
        _vm._l(_vm.daysNames, function(d) {
          return _c("th", { staticClass: "dow" }, [_vm._v(_vm._s(d))])
        })
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c(
        "tr",
        _vm._l(_vm.daysNames, function(d) {
          return _c("th", { staticClass: "dow" }, [_vm._v(_vm._s(d))])
        })
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c2f8127", esExports)
  }
}

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_image_vue__ = __webpack_require__(39);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6ffdb10_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_image_vue__ = __webpack_require__(97);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_image_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6ffdb10_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_image_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/entries/entry-image.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b6ffdb10", Component.options)
  } else {
    hotAPI.reload("data-v-b6ffdb10", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-entry-image" },
    [
      _vm.isReadonly
        ? _c("div", { class: _vm.entryClassName }, [
            _c("label", { staticClass: "show", attrs: { for: _vm.entryId } }, [
              _vm._v(_vm._s(_vm.label))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "wrapper" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "input" }, [
                _c("span", { staticClass: "readonly-value" }, [
                  _vm._v(_vm._s(_vm.value))
                ])
              ])
            ])
          ])
        : _c("div", { class: _vm.entryClassName }, [
            _c(
              "label",
              { class: { show: _vm.hasValue }, attrs: { for: _vm.entryId } },
              [_vm._v(_vm._s(_vm.label))]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "wrapper" }, [
              _c("div", { staticClass: "icon-wrapper" }, [
                _c("div", { staticClass: "icon-image" }, [
                  _c("button", {
                    class: { open: _vm.showImagePicker },
                    attrs: { type: "button" },
                    on: { click: _vm.onShowImagePicker }
                  })
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input", on: { click: _vm.onShowImagePicker } },
                [
                  _c("input", {
                    ref: "input",
                    attrs: {
                      type: "text",
                      disabled: "",
                      id: _vm.entryId,
                      name: _vm.name,
                      placeholder: _vm.hasValue
                        ? null
                        : _vm.placeholder || _vm.label
                    },
                    domProps: { value: _vm.value },
                    on: {
                      focus: function($event) {
                        _vm.onFocus(true)
                      },
                      blur: function($event) {
                        _vm.onFocus(false)
                      }
                    }
                  })
                ]
              ),
              _vm._v(" "),
              false
                ? _c("div", { staticClass: "preview" }, [_vm._m(1)])
                : _vm._e()
            ])
          ]),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [_vm.showImagePicker ? _c("image-picker") : _vm._e()],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-wrapper" }, [
      _c("div", { staticClass: "icon-image" }, [
        _c("button", { attrs: { type: "button" } })
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "img-placeholder" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b6ffdb10", esExports)
  }
}

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_image_picker_vue__ = __webpack_require__(40);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c07f3c3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_image_picker_vue__ = __webpack_require__(99);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_image_picker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c07f3c3_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_image_picker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/pickers/image-picker.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6c07f3c3", Component.options)
  } else {
    hotAPI.reload("data-v-6c07f3c3", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "image-popup" }, [
    !_vm.image
      ? _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "preview" }, [
            _c(
              "div",
              { class: { upload: true, fill: _vm.actionBrowseHover } },
              [
                _c("input", {
                  attrs: { type: "file", name: "ip1", id: "ip1" },
                  on: { change: _vm.onFileChange }
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "btn-nobg--browse",
                    attrs: { for: "ip1" },
                    on: {
                      mouseover: function($event) {
                        _vm.actionBrowseHover = true
                      },
                      mouseleave: function($event) {
                        _vm.actionBrowseHover = false
                      }
                    }
                  },
                  [_vm._v("Aggiungi immagine")]
                )
              ]
            )
          ]),
          _vm._v(" "),
          _vm._m(0)
        ])
      : _c("div", { staticClass: "content" }, [
          _c("div", { class: { preview: true, img: _vm.image } }, [
            _c("div", { staticClass: "upload" }, [
              _c("img", { attrs: { src: _vm.image } })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "action" }, [
            _c(
              "button",
              { staticClass: "btn-nobg--download", attrs: { type: "button" } },
              [_vm._v("Download")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn-nobg--delete",
                attrs: { type: "button" },
                on: { click: _vm.removeImage }
              },
              [_vm._v("Cancella")]
            )
          ])
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "action" }, [
      _c(
        "button",
        {
          staticClass: "btn-nobg--download disabled",
          attrs: { type: "button" }
        },
        [_vm._v("Download")]
      ),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "btn-nobg--delete disabled", attrs: { type: "button" } },
        [_vm._v("Cancella")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6c07f3c3", esExports)
  }
}

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_time_vue__ = __webpack_require__(41);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7255e640_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_time_vue__ = __webpack_require__(101);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_time_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7255e640_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_time_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/entries/entry-time.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7255e640", Component.options)
  } else {
    hotAPI.reload("data-v-7255e640", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.cellClassName }, [
    _vm.isReadonly
      ? _c("div", { class: _vm.entryClassName }, [
          _c("label", { staticClass: "show", attrs: { for: _vm.entryId } }, [
            _vm._v(_vm._s(_vm.label))
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "wrapper" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "input" }, [
              _c("span", { staticClass: "readonly-value" }, [
                _vm._v(_vm._s(_vm.value))
              ])
            ])
          ])
        ])
      : _c("div", { class: _vm.entryClassName }, [
          _c(
            "label",
            { class: { show: _vm.hasValue }, attrs: { for: _vm.entryId } },
            [_vm._v(_vm._s(_vm.label))]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "wrapper" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "input" }, [
              _c("input", {
                ref: "input",
                attrs: {
                  type: "text",
                  id: _vm.entryId,
                  name: _vm.name,
                  placeholder: _vm.hasValue
                    ? null
                    : _vm.placeholder || _vm.label
                },
                domProps: { value: _vm.value },
                on: {
                  input: _vm.onInput,
                  keyup: function($event) {
                    if (!("button" in $event) && $event.keyCode !== 13) {
                      return null
                    }
                    _vm.onKeyEnter($event)
                  },
                  focus: function($event) {
                    _vm.onFocus(true)
                  },
                  blur: function($event) {
                    _vm.onFocus(false)
                  }
                }
              })
            ])
          ])
        ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-wrapper" }, [
      _c("div", { staticClass: "icon-time" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-wrapper" }, [
      _c("div", { staticClass: "icon-time" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7255e640", esExports)
  }
}

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_upload_vue__ = __webpack_require__(42);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35a47cb4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_upload_vue__ = __webpack_require__(103);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_upload_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35a47cb4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_upload_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/entries/entry-upload.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-35a47cb4", Component.options)
  } else {
    hotAPI.reload("data-v-35a47cb4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-entry-upload" },
    [
      _vm.isReadonly
        ? _c("div", { class: _vm.entryClassName }, [
            _c("label", { staticClass: "show", attrs: { for: _vm.entryId } }, [
              _vm._v(_vm._s(_vm.label))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "wrapper" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "input" }, [
                _c("span", { staticClass: "readonly-value" }, [
                  _vm._v(_vm._s(_vm.value))
                ])
              ])
            ])
          ])
        : _c("div", { class: _vm.entryClassName }, [
            _c(
              "label",
              { class: { show: _vm.hasValue }, attrs: { for: _vm.entryId } },
              [_vm._v(_vm._s(_vm.label))]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "wrapper" }, [
              _c("div", { staticClass: "icon-wrapper" }, [
                _c("div", { staticClass: "icon-upload" }, [
                  _c("button", {
                    class: { open: _vm.showFilePicker },
                    attrs: { type: "button" },
                    on: { click: _vm.onShowFilePicker }
                  })
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input", on: { click: _vm.onShowFilePicker } },
                [
                  _c("input", {
                    ref: "input",
                    attrs: {
                      type: "text",
                      disabled: "",
                      id: _vm.entryId,
                      name: _vm.name,
                      placeholder: _vm.hasValue
                        ? null
                        : _vm.placeholder || _vm.label
                    },
                    domProps: { value: _vm.value },
                    on: {
                      focus: function($event) {
                        _vm.onFocus(true)
                      },
                      blur: function($event) {
                        _vm.onFocus(false)
                      }
                    }
                  })
                ]
              ),
              _vm._v(" "),
              false
                ? _c("div", { class: _vm.fileTypeClassName }, [
                    _c("div", { staticClass: "content" })
                  ])
                : _vm._e()
            ])
          ]),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [_vm.showFilePicker ? _c("file-picker") : _vm._e()],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "icon-wrapper" }, [
      _c("div", { staticClass: "icon-upload" }, [
        _c("button", { attrs: { type: "button" } })
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35a47cb4", esExports)
  }
}

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_file_picker_vue__ = __webpack_require__(43);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf297068_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_file_picker_vue__ = __webpack_require__(105);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_file_picker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bf297068_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_file_picker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/pickers/file-picker.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-bf297068", Component.options)
  } else {
    hotAPI.reload("data-v-bf297068", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "file-popup" }, [
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "preview" }, [
        _c("div", { class: { upload: true, fill: _vm.actionBrowseHover } }, [
          _c("input", { attrs: { type: "file", name: "ip1", id: "ip1" } }),
          _vm._v(" "),
          _c(
            "label",
            {
              staticClass: "btn-nobg--browse",
              attrs: { for: "ip1" },
              on: {
                mouseover: function($event) {
                  _vm.actionBrowseHover = true
                },
                mouseleave: function($event) {
                  _vm.actionBrowseHover = false
                }
              }
            },
            [
              _vm._v(
                "\n                    Aggiungi documento\n                "
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _vm._m(0)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "action" }, [
      _c(
        "button",
        {
          staticClass: "btn-nobg--download disabled",
          attrs: { type: "button" }
        },
        [_vm._v("Download")]
      ),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "btn-nobg--delete disabled", attrs: { type: "button" } },
        [_vm._v("Cancella")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bf297068", esExports)
  }
}

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_html_vue__ = __webpack_require__(44);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4be207c4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_html_vue__ = __webpack_require__(116);
var disposed = false
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__ts_loader_node_modules_vue_loader_lib_selector_type_script_index_0_entry_html_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4be207c4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_entry_html_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/entries/entry-html.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4be207c4", Component.options)
  } else {
    hotAPI.reload("data-v-4be207c4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setup */
/* unused harmony export schema */
/* harmony export (immutable) */ __webpack_exports__["a"] = createEditor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_history__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_history___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_history__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_commands__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_commands___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_commands__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_state__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prosemirror_gapcursor__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prosemirror_gapcursor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prosemirror_gapcursor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prosemirror_menu__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prosemirror_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prosemirror_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__menu__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__keymap__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__inputrules__ = __webpack_require__(113);
/* unused harmony reexport buildMenuItems */
/* unused harmony reexport buildKeymap */
/* unused harmony reexport buildInputRules */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prosemirror_view__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prosemirror_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prosemirror_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prosemirror_model__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prosemirror_model___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prosemirror_model__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prosemirror_schema_basic__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prosemirror_schema_basic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prosemirror_schema_basic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prosemirror_schema_list__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prosemirror_schema_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prosemirror_schema_list__);




//import { dropCursor } from 'prosemirror-dropcursor'






// !! This module exports helper functions for deriving a set of basic
// menu items, input rules, or key bindings from a schema. These
// values need to know about the schema for two reasons—they need
// access to specific instances of node and mark types, and they need
// to know which of the node and mark types that they know about are
// actually present in the schema.
//
// The `exampleSetup` plugin ties these together into a plugin that
// will automatically enable this basic functionality in an editor.
// :: (Object) → [Plugin]
// A convenience plugin that bundles together a simple menu with basic
// key bindings, input rules, and styling for the example schema.
// Probably only useful for quickly setting up a passable
// editor—you'll need more control over your settings in most
// real-world situations.
//
//   options::- The following options are recognized:
//
//     schema:: Schema
//     The schema to generate key bindings and menu items for.
//
//     mapKeys:: ?Object
//     Can be used to [adjust](#example-setup.buildKeymap) the key bindings created.
//
//     menuBar:: ?bool
//     Set to false to disable the menu bar.
//
//     menuContent:: [[MenuItem]]
//     Can be used to override the menu content.
function setup(options) {
    var plugins = [
        Object(__WEBPACK_IMPORTED_MODULE_8__inputrules__["a" /* buildInputRules */])(options.schema),
        Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__["keymap"])(Object(__WEBPACK_IMPORTED_MODULE_7__keymap__["a" /* buildKeymap */])(options.schema, options.mapKeys)),
        Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_keymap__["keymap"])(__WEBPACK_IMPORTED_MODULE_2_prosemirror_commands__["baseKeymap"]),
        //dropCursor(),
        Object(__WEBPACK_IMPORTED_MODULE_4_prosemirror_gapcursor__["gapCursor"])(),
        Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_history__["history"])()
    ];
    if (options.menuBar !== false) {
        plugins.push(Object(__WEBPACK_IMPORTED_MODULE_5_prosemirror_menu__["menuBar"])({
            floating: false,
            content: options.menuContent || Object(__WEBPACK_IMPORTED_MODULE_6__menu__["a" /* buildMenuItems */])(options.schema).fullMenu
        }));
    }
    return plugins.concat(new __WEBPACK_IMPORTED_MODULE_3_prosemirror_state__["Plugin"]({
        props: {
            attributes: { class: 'html-editor-wrapper' }
        }
    }));
}
// Default editor





// Mix the nodes from prosemirror-schema-list into the basic schema to
// create a schema with list support.
var schema = new __WEBPACK_IMPORTED_MODULE_10_prosemirror_model__["Schema"]({
    nodes: Object(__WEBPACK_IMPORTED_MODULE_12_prosemirror_schema_list__["addListNodes"])(__WEBPACK_IMPORTED_MODULE_11_prosemirror_schema_basic__["schema"].spec.nodes, "paragraph block*", "block"),
    marks: __WEBPACK_IMPORTED_MODULE_11_prosemirror_schema_basic__["schema"].spec.marks
});
function createEditor(node, initialContent, handleTransaction, handleFocus, handleBlur) {
    var content = document.createElement("div");
    content.innerHTML = initialContent;
    return new __WEBPACK_IMPORTED_MODULE_9_prosemirror_view__["EditorView"](node, {
        state: __WEBPACK_IMPORTED_MODULE_3_prosemirror_state__["EditorState"].create({
            doc: __WEBPACK_IMPORTED_MODULE_10_prosemirror_model__["DOMParser"].fromSchema(schema).parse(content),
            plugins: setup({ schema: schema })
        }),
        dispatchTransaction: handleTransaction,
        handleDOMEvents: {
            focus: handleFocus,
            blur: handleBlur
        }
    });
}


/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports = require("prosemirror-keymap");

/***/ }),
/* 109 */
/***/ (function(module, exports) {

module.exports = require("prosemirror-gapcursor");

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildMenuItems;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_menu__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_state___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_state__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_commands__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_commands___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_commands__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_schema_list__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_schema_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prosemirror_schema_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__prompt__ = __webpack_require__(111);





// Helpers to create specific types of items
function canInsert(state, nodeType) {
    var $from = state.selection.$from;
    for (var d = $from.depth; d >= 0; d--) {
        var index = $from.index(d);
        if ($from.node(d).canReplaceWith(index, index, nodeType)) {
            return true;
        }
    }
    return false;
}
function insertImageItem(nodeType) {
    return new __WEBPACK_IMPORTED_MODULE_0_prosemirror_menu__["MenuItem"]({
        title: 'Insert image',
        label: 'Image',
        enable: function (state) { return canInsert(state, nodeType); },
        run: function (state, _, view) {
            var _a = state.selection, from = _a.from, to = _a.to, attrs = null;
            if (state.selection instanceof __WEBPACK_IMPORTED_MODULE_1_prosemirror_state__["NodeSelection"] && state.selection.node.type == nodeType)
                attrs = state.selection.node.attrs;
            Object(__WEBPACK_IMPORTED_MODULE_4__prompt__["b" /* openPrompt */])({
                title: 'Insert image',
                fields: {
                    src: new __WEBPACK_IMPORTED_MODULE_4__prompt__["a" /* TextField */]({ label: 'Location', required: true, value: attrs && attrs.src }),
                    title: new __WEBPACK_IMPORTED_MODULE_4__prompt__["a" /* TextField */]({ label: 'Title', value: attrs && attrs.title }),
                    alt: new __WEBPACK_IMPORTED_MODULE_4__prompt__["a" /* TextField */]({
                        label: 'Description',
                        value: attrs ? attrs.alt : state.doc.textBetween(from, to, ' ')
                    })
                },
                callback: function (attrs) {
                    view.dispatch(view.state.tr.replaceSelectionWith(nodeType.createAndFill(attrs)));
                    view.focus();
                }
            });
        }
    });
}
function cmdItem(cmd, options) {
    var passedOptions = {
        label: options.title,
        run: cmd
    };
    for (var prop in options)
        passedOptions[prop] = options[prop];
    if ((!options.enable || options.enable === true) && !options.select)
        passedOptions[options.enable ? 'enable' : 'select'] = function (state) { return cmd(state); };
    return new __WEBPACK_IMPORTED_MODULE_0_prosemirror_menu__["MenuItem"](passedOptions);
}
function markActive(state, type) {
    var _a = state.selection, from = _a.from, $from = _a.$from, to = _a.to, empty = _a.empty;
    if (empty) {
        return type.isInSet(state.storedMarks || $from.marks());
    }
    else {
        return state.doc.rangeHasMark(from, to, type);
    }
}
function markItem(markType, options) {
    var passedOptions = {
        active: function (state) { return markActive(state, markType); },
        enable: true
    };
    for (var prop in options) {
        passedOptions[prop] = options[prop];
    }
    return cmdItem(Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_commands__["toggleMark"])(markType), passedOptions);
}
function linkItem(markType) {
    return new __WEBPACK_IMPORTED_MODULE_0_prosemirror_menu__["MenuItem"]({
        title: 'Add or remove link',
        icon: __WEBPACK_IMPORTED_MODULE_0_prosemirror_menu__["icons"].link,
        active: function (state) { return markActive(state, markType); },
        enable: function (state) { return !state.selection.empty; },
        run: function (state, dispatch, view) {
            if (markActive(state, markType)) {
                Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_commands__["toggleMark"])(markType)(state, dispatch);
                return true;
            }
            Object(__WEBPACK_IMPORTED_MODULE_4__prompt__["b" /* openPrompt */])({
                title: 'Create a link',
                fields: {
                    href: new __WEBPACK_IMPORTED_MODULE_4__prompt__["a" /* TextField */]({
                        label: 'Link target',
                        required: true
                    }),
                    title: new __WEBPACK_IMPORTED_MODULE_4__prompt__["a" /* TextField */]({ label: 'Title' })
                },
                callback: function (attrs) {
                    Object(__WEBPACK_IMPORTED_MODULE_2_prosemirror_commands__["toggleMark"])(markType, attrs)(view.state, view.dispatch);
                    view.focus();
                }
            });
        }
    });
}
function wrapListItem(nodeType, options) {
    return cmdItem(Object(__WEBPACK_IMPORTED_MODULE_3_prosemirror_schema_list__["wrapInList"])(nodeType, options.attrs), options);
}
// :: (Schema) → Object
// Given a schema, look for default mark and node types in it and
// return an object with relevant menu items relating to those marks:
//
// **`toggleStrong`**`: MenuItem`
//   : A menu item to toggle the [strong mark](#schema-basic.StrongMark).
//
// **`toggleEm`**`: MenuItem`
//   : A menu item to toggle the [emphasis mark](#schema-basic.EmMark).
//
// **`toggleCode`**`: MenuItem`
//   : A menu item to toggle the [code font mark](#schema-basic.CodeMark).
//
// **`toggleLink`**`: MenuItem`
//   : A menu item to toggle the [link mark](#schema-basic.LinkMark).
//
// **`insertImage`**`: MenuItem`
//   : A menu item to insert an [image](#schema-basic.Image).
//
// **`wrapBulletList`**`: MenuItem`
//   : A menu item to wrap the selection in a [bullet list](#schema-list.BulletList).
//
// **`wrapOrderedList`**`: MenuItem`
//   : A menu item to wrap the selection in an [ordered list](#schema-list.OrderedList).
//
// **`wrapBlockQuote`**`: MenuItem`
//   : A menu item to wrap the selection in a [block quote](#schema-basic.BlockQuote).
//
// **`makeParagraph`**`: MenuItem`
//   : A menu item to set the current textblock to be a normal
//     [paragraph](#schema-basic.Paragraph).
//
// **`makeCodeBlock`**`: MenuItem`
//   : A menu item to set the current textblock to be a
//     [code block](#schema-basic.CodeBlock).
//
// **`makeHead[N]`**`: MenuItem`
//   : Where _N_ is 1 to 6. Menu items to set the current textblock to
//     be a [heading](#schema-basic.Heading) of level _N_.
//
// **`insertHorizontalRule`**`: MenuItem`
//   : A menu item to insert a horizontal rule.
//
// The return value also contains some prefabricated menu elements and
// menus, that you can use instead of composing your own menu from
// scratch:
//
// **`insertMenu`**`: Dropdown`
//   : A dropdown containing the `insertImage` and
//     `insertHorizontalRule` items.
//
// **`typeMenu`**`: Dropdown`
//   : A dropdown containing the items for making the current
//     textblock a paragraph, code block, or heading.
//
// **`fullMenu`**`: [[MenuElement]]`
//   : An array of arrays of menu elements for use as the full menu
//     for, for example the [menu bar](https://github.com/prosemirror/prosemirror-menu#user-content-menubar).
function buildMenuItems(schema) {
    var r = {}, type;
    if (type = schema.marks.strong) {
        r.toggleStrong = markItem(type, {
            title: 'Toggle strong style',
            icon: __WEBPACK_IMPORTED_MODULE_0_prosemirror_menu__["icons"].strong
        });
    }
    if (type = schema.marks.em) {
        r.toggleEm = markItem(type, {
            title: 'Toggle emphasis',
            icon: __WEBPACK_IMPORTED_MODULE_0_prosemirror_menu__["icons"].em
        });
    }
    if (type = schema.marks.link) {
        r.toggleLink = linkItem(type);
    }
    if (type = schema.nodes.bullet_list) {
        r.wrapBulletList = wrapListItem(type, {
            title: 'Wrap in bullet list',
            icon: __WEBPACK_IMPORTED_MODULE_0_prosemirror_menu__["icons"].bulletList
        });
    }
    if (type = schema.nodes.ordered_list) {
        r.wrapOrderedList = wrapListItem(type, {
            title: 'Wrap in ordered list',
            icon: __WEBPACK_IMPORTED_MODULE_0_prosemirror_menu__["icons"].orderedList
        });
    }
    /* if (type = schema.nodes.image)
        r.insertImage = insertImageItem(type) */
    /* if (type = schema.marks.code)
        r.toggleCode = markItem(type, { title: 'Toggle code font', icon: icons.code }) */
    /* if (type = schema.nodes.blockquote)
        r.wrapBlockQuote = wrapItem(type, {
            title: 'Wrap in block quote',
            icon: icons.blockquote
        }) */
    /* if (type = schema.nodes.paragraph)
        r.makeParagraph = blockTypeItem(type, {
            title: 'Change to paragraph',
            label: 'Plain'
        }) */
    /* if (type = schema.nodes.code_block)
        r.makeCodeBlock = blockTypeItem(type, {
            title: 'Change to code block',
            label: 'Code'
        }) */
    /* if (type = schema.nodes.heading)
        for (let i = 1; i <= 10; i++)
            r['makeHead' + i] = blockTypeItem(type, {
                title: 'Change to heading ' + i,
                label: 'Level ' + i,
                attrs: { level: i }
            }) */
    /* if (type = schema.nodes.horizontal_rule) {
        let hr = type
        r.insertHorizontalRule = new MenuItem(<any>{
            title: 'Insert horizontal rule',
            label: 'Horizontal rule',
            enable(state: any) { return canInsert(state, hr) },
            run(state: any, dispatch: any) { dispatch(state.tr.replaceSelectionWith(hr.create())) }
        })
    } */
    var cut = function (arr) { return arr.filter(function (x) { return x; }); };
    r.fullMenu = [cut([r.toggleStrong, r.toggleEm, r.toggleCode, r.toggleLink, __WEBPACK_IMPORTED_MODULE_0_prosemirror_menu__["undoItem"], __WEBPACK_IMPORTED_MODULE_0_prosemirror_menu__["redoItem"], r.wrapBulletList, r.wrapOrderedList])];
    return r;
}


/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = openPrompt;
/* unused harmony export Field */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TextField; });
/* unused harmony export SelectField */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var prefix = "html-editor-popup";
function openPrompt(options) {
    var wrapper = document.body.appendChild(document.createElement("div"));
    wrapper.className = prefix;
    var mouseOutside = function (e) { if (!wrapper.contains(e.target))
        close(); };
    setTimeout(function () { return window.addEventListener("mousedown", mouseOutside); }, 50);
    var close = function () {
        window.removeEventListener("mousedown", mouseOutside);
        if (wrapper.parentNode)
            wrapper.parentNode.removeChild(wrapper);
    };
    var domFields = [];
    for (var name_1 in options.fields)
        domFields.push(options.fields[name_1].render());
    var submitButton = document.createElement("button");
    submitButton.type = "submit";
    submitButton.className = prefix + "-submit";
    submitButton.textContent = "OK";
    var cancelButton = document.createElement("button");
    cancelButton.type = "button";
    cancelButton.className = prefix + "-cancel";
    cancelButton.textContent = "Cancel";
    cancelButton.addEventListener("click", close);
    var form = wrapper.appendChild(document.createElement("form"));
    if (options.title)
        form.appendChild(document.createElement("h5")).textContent = options.title;
    domFields.forEach(function (field) {
        form.appendChild(document.createElement("div")).appendChild(field);
    });
    var buttons = form.appendChild(document.createElement("div"));
    buttons.className = prefix + "-buttons";
    buttons.appendChild(submitButton);
    buttons.appendChild(document.createTextNode(" "));
    buttons.appendChild(cancelButton);
    var box = wrapper.getBoundingClientRect();
    wrapper.style.top = ((window.innerHeight - box.height) / 2) + "px";
    wrapper.style.left = ((window.innerWidth - box.width) / 2) + "px";
    var submit = function () {
        var params = getValues(options.fields, domFields);
        if (params) {
            close();
            options.callback(params);
        }
    };
    form.addEventListener("submit", function (e) {
        e.preventDefault();
        submit();
    });
    form.addEventListener("keydown", function (e) {
        if (e.keyCode == 27) {
            e.preventDefault();
            close();
        }
        else if (e.keyCode == 13 && !(e.ctrlKey || e.metaKey || e.shiftKey)) {
            e.preventDefault();
            submit();
        }
        else if (e.keyCode == 9) {
            window.setTimeout(function () {
                if (!wrapper.contains(document.activeElement))
                    close();
            }, 500);
        }
    });
    var input = form.elements[0];
    if (input)
        input.focus();
}
function getValues(fields, domFields) {
    var result = Object.create(null), i = 0;
    for (var name_2 in fields) {
        var field = fields[name_2], dom = domFields[i++];
        var value = field.read(dom), bad = field.validate(value);
        if (bad) {
            reportInvalid(dom, bad);
            return null;
        }
        result[name_2] = field.clean(value);
    }
    return result;
}
function reportInvalid(dom, message) {
    // FIXME this is awful and needs a lot more work
    var parent = dom.parentNode;
    var msg = parent.appendChild(document.createElement("div"));
    msg.style.left = (dom.offsetLeft + dom.offsetWidth + 2) + "px";
    msg.style.top = (dom.offsetTop - 5) + "px";
    msg.className = "html-editor-invalid";
    msg.textContent = message;
    setTimeout(function () { return parent.removeChild(msg); }, 1500);
}
// ::- The type of field that `FieldPrompt` expects to be passed to it.
var Field = /** @class */ (function () {
    // :: (Object)
    // Create a field with the given options. Options support by all
    // field types are:
    //
    // **`value`**`: ?any`
    //   : The starting value for the field.
    //
    // **`label`**`: string`
    //   : The label for the field.
    //
    // **`required`**`: ?bool`
    //   : Whether the field is required.
    //
    // **`validate`**`: ?(any) → ?string`
    //   : A function to validate the given value. Should return an
    //     error message if it is not valid.
    function Field(options) {
        this.options = options;
    }
    // render:: (state: EditorState, props: Object) → dom.Node
    // Render the field to the DOM. Should be implemented by all subclasses.
    // :: (dom.Node) → any
    // Read the field's value from its DOM node.
    Field.prototype.read = function (dom) { return dom.value; };
    // :: (any) → ?string
    // A field-type-specific validation function.
    Field.prototype.validateType = function (_value) { };
    Field.prototype.validate = function (value) {
        if (!value && this.options.required)
            return "Required field";
        return this.validateType(value) || (this.options.validate && this.options.validate(value));
    };
    Field.prototype.clean = function (value) {
        return this.options.clean ? this.options.clean(value) : value;
    };
    return Field;
}());

// ::- A field class for single-line text fields.
var TextField = /** @class */ (function (_super) {
    __extends(TextField, _super);
    function TextField() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TextField.prototype.render = function () {
        var input = document.createElement("input");
        input.type = "text";
        input.placeholder = this.options.label;
        input.value = this.options.value || "";
        input.autocomplete = "off";
        return input;
    };
    return TextField;
}(Field));

// ::- A field class for dropdown fields based on a plain `<select>`
// tag. Expects an option `options`, which should be an array of
// `{value: string, label: string}` objects, or a function taking a
// `ProseMirror` instance and returning such an array.
var SelectField = /** @class */ (function (_super) {
    __extends(SelectField, _super);
    function SelectField() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SelectField.prototype.render = function () {
        var _this = this;
        var select = document.createElement("select");
        this.options.options.forEach(function (o) {
            var opt = select.appendChild(document.createElement("option"));
            opt.value = o.value;
            opt.selected = o.value == _this.options.value;
            opt.label = o.label;
        });
        return select;
    };
    return SelectField;
}(Field));



/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildKeymap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_commands___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_schema_list__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prosemirror_schema_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prosemirror_schema_list__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_history__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prosemirror_history___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prosemirror_history__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_inputrules__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prosemirror_inputrules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prosemirror_inputrules__);




var mac = typeof navigator != "undefined" ? /Mac/.test(navigator.platform) : false;
// :: (Schema, ?Object) → Object
// Inspect the given schema looking for marks and nodes from the
// basic schema, and if found, add key bindings related to them.
// This will add:
//
// * **Mod-b** for toggling [strong](#schema-basic.StrongMark)
// * **Mod-i** for toggling [emphasis](#schema-basic.EmMark)
// * **Mod-`** for toggling [code font](#schema-basic.CodeMark)
// * **Ctrl-Shift-0** for making the current textblock a paragraph
// * **Ctrl-Shift-1** to **Ctrl-Shift-Digit6** for making the current
//   textblock a heading of the corresponding level
// * **Ctrl-Shift-Backslash** to make the current textblock a code block
// * **Ctrl-Shift-8** to wrap the selection in an ordered list
// * **Ctrl-Shift-9** to wrap the selection in a bullet list
// * **Ctrl->** to wrap the selection in a block quote
// * **Enter** to split a non-empty textblock in a list item while at
//   the same time splitting the list item
// * **Mod-Enter** to insert a hard break
// * **Mod-_** to insert a horizontal rule
// * **Backspace** to undo an input rule
// * **Alt-ArrowUp** to `joinUp`
// * **Alt-ArrowDown** to `joinDown`
// * **Mod-BracketLeft** to `lift`
// * **Escape** to `selectParentNode`
//
// You can suppress or map these bindings by passing a `mapKeys`
// argument, which maps key names (say `"Mod-B"` to either `false`, to
// remove the binding, or a new key name string.
function buildKeymap(schema, mapKeys) {
    var keys = {}, type;
    function bind(key, cmd) {
        if (mapKeys) {
            var mapped = mapKeys[key];
            if (mapped === false) {
                return;
            }
            if (mapped) {
                key = mapped;
            }
        }
        keys[key] = cmd;
    }
    bind("Mod-z", __WEBPACK_IMPORTED_MODULE_2_prosemirror_history__["undo"]);
    bind("Shift-Mod-z", __WEBPACK_IMPORTED_MODULE_2_prosemirror_history__["redo"]);
    bind("Backspace", __WEBPACK_IMPORTED_MODULE_3_prosemirror_inputrules__["undoInputRule"]);
    if (!mac) {
        bind("Mod-y", __WEBPACK_IMPORTED_MODULE_2_prosemirror_history__["redo"]);
    }
    bind("Alt-ArrowUp", __WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["joinUp"]);
    bind("Alt-ArrowDown", __WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["joinDown"]);
    bind("Mod-BracketLeft", __WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["lift"]);
    bind("Escape", __WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["selectParentNode"]);
    if (type = schema.marks.strong) {
        bind("Mod-b", Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["toggleMark"])(type));
    }
    if (type = schema.marks.em) {
        bind("Mod-i", Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["toggleMark"])(type));
    }
    if (type = schema.marks.code) {
        bind("Mod-`", Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["toggleMark"])(type));
    }
    if (type = schema.nodes.bullet_list) {
        bind("Shift-Ctrl-8", Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_schema_list__["wrapInList"])(type));
    }
    if (type = schema.nodes.ordered_list) {
        bind("Shift-Ctrl-9", Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_schema_list__["wrapInList"])(type));
    }
    if (type = schema.nodes.blockquote) {
        bind("Ctrl->", Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["wrapIn"])(type));
    }
    if (type = schema.nodes.hard_break) {
        var br_1 = type, cmd = Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["chainCommands"])(__WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["exitCode"], function (state, dispatch) {
            dispatch(state.tr.replaceSelectionWith(br_1.create()).scrollIntoView());
            return true;
        });
        bind("Mod-Enter", cmd);
        bind("Shift-Enter", cmd);
        if (mac) {
            bind("Ctrl-Enter", cmd);
        }
    }
    if (type = schema.nodes.list_item) {
        bind("Enter", Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_schema_list__["splitListItem"])(type));
        bind("Mod-[", Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_schema_list__["liftListItem"])(type));
        bind("Mod-]", Object(__WEBPACK_IMPORTED_MODULE_1_prosemirror_schema_list__["sinkListItem"])(type));
    }
    if (type = schema.nodes.paragraph) {
        bind("Shift-Ctrl-0", Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["setBlockType"])(type));
    }
    if (type = schema.nodes.code_block) {
        bind("Shift-Ctrl-\\", Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["setBlockType"])(type));
    }
    if (type = schema.nodes.heading) {
        for (var i = 1; i <= 6; i++) {
            bind("Shift-Ctrl-" + i, Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_commands__["setBlockType"])(type, { level: i }));
        }
    }
    if (type = schema.nodes.horizontal_rule) {
        var hr_1 = type;
        bind("Mod-_", function (state, dispatch) {
            dispatch(state.tr.replaceSelectionWith(hr_1.create()).scrollIntoView());
            return true;
        });
    }
    return keys;
}


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export blockQuoteRule */
/* unused harmony export orderedListRule */
/* unused harmony export bulletListRule */
/* unused harmony export codeBlockRule */
/* unused harmony export headingRule */
/* harmony export (immutable) */ __webpack_exports__["a"] = buildInputRules;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__);

// : (NodeType) → InputRule
// Given a blockquote node type, returns an input rule that turns `'> '`
// at the start of a textblock into a blockquote.
function blockQuoteRule(nodeType) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__["wrappingInputRule"])(/^\s*>\s$/, nodeType);
}
// : (NodeType) → InputRule
// Given a list node type, returns an input rule that turns a number
// followed by a dot at the start of a textblock into an ordered list.
function orderedListRule(nodeType) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__["wrappingInputRule"])(/^(\d+)\.\s$/, nodeType, function (match) { return ({ order: +match[1] }); }, function (match, node) { return node.childCount + node.attrs.order == +match[1]; });
}
// : (NodeType) → InputRule
// Given a list node type, returns an input rule that turns a bullet
// (dash, plush, or asterisk) at the start of a textblock into a
// bullet list.
function bulletListRule(nodeType) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__["wrappingInputRule"])(/^\s*([-+*])\s$/, nodeType);
}
// : (NodeType) → InputRule
// Given a code block node type, returns an input rule that turns a
// textblock starting with three backticks into a code block.
function codeBlockRule(nodeType) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__["textblockTypeInputRule"])(/^```$/, nodeType);
}
// : (NodeType, number) → InputRule
// Given a node type and a maximum level, creates an input rule that
// turns up to that number of `#` characters followed by a space at
// the start of a textblock into a heading whose level corresponds to
// the number of `#` signs.
function headingRule(nodeType, maxLevel) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__["textblockTypeInputRule"])(new RegExp('^(#{1,' + maxLevel + '})\\s$'), nodeType, function (match) { return ({ level: match[1].length }); });
}
// : (Schema) → Plugin
// A set of input rules for creating the basic block quotes, lists,
// code blocks, and heading.
function buildInputRules(schema) {
    var rules = __WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__["smartQuotes"].concat(__WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__["ellipsis"], __WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__["emDash"]), type;
    if (type = schema.nodes.blockquote) {
        rules.push(blockQuoteRule(type));
    }
    if (type = schema.nodes.ordered_list) {
        rules.push(orderedListRule(type));
    }
    if (type = schema.nodes.bullet_list) {
        rules.push(bulletListRule(type));
    }
    if (type = schema.nodes.code_block) {
        rules.push(codeBlockRule(type));
    }
    if (type = schema.nodes.heading) {
        rules.push(headingRule(type, 6));
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0_prosemirror_inputrules__["inputRules"])({ rules: rules });
}


/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports = require("prosemirror-view");

/***/ }),
/* 115 */
/***/ (function(module, exports) {

module.exports = require("prosemirror-schema-basic");

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "c-entry-html" }, [
    _vm.isReadonly
      ? _c("div", { class: _vm.entryClassName }, [
          _c("label", { staticClass: "show", attrs: { for: _vm.entryId } }, [
            _vm._v(_vm._s(_vm.label))
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "readonly-value" }, [
            _vm._v(_vm._s(_vm.value))
          ])
        ])
      : _c("div", { class: _vm.entryClassName }, [
          _c(
            "label",
            { class: { show: _vm.hasValue }, attrs: { for: _vm.entryId } },
            [_vm._v(_vm._s(_vm.label))]
          ),
          _vm._v(" "),
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.value,
                expression: "value"
              }
            ],
            ref: "textarea",
            staticStyle: { display: "none" },
            attrs: { id: _vm.entryId, name: _vm.name },
            domProps: { value: _vm.value },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.value = $event.target.value
              }
            }
          }),
          _vm._v(" "),
          _c("div", { ref: "editor" })
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4be207c4", esExports)
  }
}

/***/ })
/******/ ]);
});
//# sourceMappingURL=pack.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/wok-forms/dist/pack.js
// module id = 53
// module chunks = 0